<template>
  <div>
  <div class="shipments relative full-page-width ex-small-width booking">
    <!-- INFO BOX -->
    <message v-if="draftError" style="margin-bottom: 25px" name="error" :data="data={data:draftError, type:'validation'}"></message>
    <div
      v-if="showSaveDialog"
      class="selection-header-close">
      <div class="m-l-10 selection-header-text">
      <p class="info-text m-r-15">
        <span>{{ $t('MSG_SAVE_DRAFT') }}</span>
      </p>
      <Btn
        class="d-inline-block brand m-r-5"
        :icon="{
        name: 'agreements',
        size: '16',
      }"
        :btnText="$t('LBL_SAVE_DRAFT')"
        @btnClick="saveDraft" />
      <Btn
        class="d-inline-block light m-r-5"
        :icon="{
        name: 'ban',
        size: '16',
      }"
        :btnText="$t('LBL_DONT_SAVE')"
        @btnClick="handleDontSave" />
      </div>
      <div class="m-r-20 selection-header-close-button" @click="handleCancel">
      <Icon
        style="cursor: pointer;"
        name="remove"
        size="24"
        fillColor="#fff" />
      </div>
    </div>
    <div v-if="get_user.show_quote_price_button" class="m-b-40 text-center">
      <TogglePill
        v-model="bookingType"
        :options="[
        { text: $t('LBL_BOOK'), value: 'standard' },
        { text: $t('LBL_QUOTE_PRICE'), value: 'quote' }
      ]"
      />
    </div>
    <!-- ACCOUNT SELECTION - Moved to the top -->
    <div v-if="getShowInfoBox()" class="m-b-40">
      <message style="margin-bottom: 25px" name="warning" :data="data={data:$t('confirm_selection_of_account'), type:'validation'}">
        <SubaccountSelect
          style="display: flex; flex-grow: 1; margin-left: 10px; align-self: center; margin: 0 0 0 20px;"
          :show-search="false"
          :default-text="$t('select_account')"
          :multiSelect="false"
          v-model="bookingSubaccount"
          @change="setBookingSubaccount"
          class="m-b-20"
        />
      </message>
    </div>

    <!-- Only show the rest of the form if no account selection is needed OR if an account has been selected -->
    <div v-if="isInitialized && (!getShowInfoBox() || (getShowInfoBox() && bookingSubaccount))">
    <div v-if="bookingType === 'quote'" class="m-b-50">

      <div  style="display: grid; grid-template-columns: minmax(0,1fr) auto minmax(0,1fr); align-items: start;" class="m-b-40">

      <div class="text-box w-100">
        <h2 class="m-b-20 section-title">{{ $t('Where do you ship from') }}</h2>
        <div class="row">
          <div class="col-xs-12">
            <div class="card">
              <div class="radio-label">{{ $t('shipper_type') }}</div>
              <div class="m-b-input radio-group">
                <Radio
                  :name="'shipperTypeQuote'"
                  :text="$t('LBL_COMPANY')"
                  :value="'company'"
                  :checked="shipperType === 'company'"
                  @input="onChangeShipperType"
                />
                <Radio
                  :name="'shipperTypeQuote'"
                  :text="$t('LBL_PRIVATE')"
                  :value="'private'"
                  :checked="shipperType === 'private'"
                  @input="onChangeShipperType"
                />
              </div>
              <div class="row">
                <div class="col-xs-6">
                  <CountrySelect
                    :label="$t('sender_country')"
                    v-model="fromAddress.country_id"
                    :countryFlag="true"
                    :no-continent="true"
                  />
                </div>
                <div class="col-xs-6">
                  <InputText
                    v-model="fromAddress.post_code"
                    :label="$t('sender_postcode')"
                    :rules="{required: postCodeRequired('from')}"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Swap Button -->
      <div style="display: flex; align-items: center; align-self: center; justify-self: center;">
        <div @click="swapData" class="m-l-20 m-r-20 button-bar shadowed flex-column p-10 f-s-10">
          <Icon
            name="swapHorizontal"
            size="32"
          />
          <div style="display: block">{{ $t('LBL_SWAP').toUpperCase() }}</div>
        </div>
      </div>

      <!-- To Address -->
      <div class="text-box w-100">
        <h2 class="m-b-20 section-title">{{ $t('Where do you ship to') }}</h2>
        <div class="row">
          <div class="col-xs-12">
            <div class="card">
              <div class="radio-label">{{ $t('receiver_type') }}</div>
              <div class="m-b-input radio-group">
                <Radio
                  :name="'receiverTypeQuote'"
                  :text="$t('LBL_COMPANY')"
                  :value="'company'"
                  :checked="receiverType === 'company'"
                  @input="onChangeReceiverType"
                />
                <Radio
                  :name="'receiverTypeQuote'"
                  :text="$t('LBL_PRIVATE')"
                  :value="'private'"
                  :checked="receiverType === 'private'"
                  @input="onChangeReceiverType"
                />
              </div>
              <div class="row">
                <div class="col-xs-6">
                  <CountrySelect
                    :label="$t('receiver_country')"
                    v-model="toAddress.country_id"
                    :countryFlag="true"
                    :no-continent="true"
                  />
                </div>
                <div class="col-xs-6">
                  <InputText
                    v-model="toAddress.post_code"
                    :label="$t('receiver_post_code')"
                    :rules="{required: postCodeRequired('to')}"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

      <!-- Original Goods Components -->
      <div class="text-box">
        <div class="row" v-for="(item, index) in shipmentPackages" :key="`${item.goodsTypeName}-${index}`">
          <div v-if="item.goodsType === 2 && get_parcel_types != null" class="col-xs-12">
            <DocumentBlock
              :label="`#${index+1} - ${$t(item.goodsTypeName)}`"
              v-model="shipmentPackages[index]"
              :indexNo="`${index}`"
              :removable="shipmentPackages.length > 1"
              :showColliAmount="showColliAmount"
              :customId="`palletID-${index}`"
              @removeDocument="removePackage(index)"
              @activePackageGoodsType="updateGoodsType($event, index)"/>
          </div>
          <div v-if="item.goodsType === 1 && get_parcel_types != null" class="col-xs-12">
            <ParcelBlock
              v-model="shipmentPackages[index]"
              :indexNo="`${index}`"
              :showTemperature="false"
              :showDangerousGoods="showDangerousGoods"
              :showOnlyDescription="false"
              :isCustomsInvoiceUploaded="false"
              :customId="`parcelID-${index}`"
              :label="`#${index+1} - ${$t(item.goodsTypeName)}`"
              :removable="shipmentPackages.length > 1"
              :showOrigin="false"
              :showCustoms="false"
              :showColliContent="false"
              :showColliAmount="showColliAmount"
              :showColliDescription="false"
              :isShipmentInEdit="get_shipment_editing_mode"
              :useContentOnShipmentLevel="useContentOnShipmentLevel"
              :dgTypeShownOnPackageCustomId="dgTypeShownOnPackageCustomId"
              @removeParcel="removePackage(index)"
              @activePackageGoodsType="updateGoodsType($event, index)"
              @packagingTypeChange="packagingTypeChange(index)"
              @packagingTypeOptionChange="packagingTypeOptionChange(index)"
              @dgTypeChanged="dgTypeChanged($event, index)"
            />
          </div>
          <div v-if="item.goodsType === 3 && get_parcel_types != null" class="col-xs-12">
            <PalleteBlock
              v-model="shipmentPackages[index]"
              :indexNo="`${index}`"
              :showTemperature="false"
              :showDangerousGoods="showDangerousGoods"
              :isCustomsInvoiceUploaded="false"
              :showOnlyDescription="false"
              :label="`#${index+1} - ${$t(item.goodsTypeName)}`"
              :customId="`palletID-${index}`"
              :removable="shipmentPackages.length > 1"
              :showOrigin="false"
              :showCustoms="false"
              :showColliContent="false"
              :showColliAmount="showColliAmount"
              :showColliDescription="false"
              :dgTypeShownOnPackageCustomId="dgTypeShownOnPackageCustomId"
              :useContentOnShipmentLevel="useContentOnShipmentLevel"
              @removePallet="removePackage(index)"
              @activePackageGoodsType="updateGoodsType($event, index)"
              @palletExchangeUpdated="palletExchangeServiceCheck"
              @packagingTypeChange="packagingTypeChange(index)"
              @packagingTypeOptionChange="packagingTypeOptionChange(index)"
              @dgTypeChanged="dgTypeChanged($event, index)"
            />
          </div>
          <div v-if="item.goodsType === 4 && get_parcel_types != null" class="col-xs-12">
            <LoadBlock
              v-model="shipmentPackages[index]"
              :showTemperature="false"
              :showDangerousGoods="showDangerousGoods"
              :isCustomsInvoiceUploaded="false"
              :showOnlyDescription="false"
              :customId="`loadID-${index}`"
              :label="`#${index+1} - ${$t(item.goodsTypeName)}`"
              :showOrigin="false"
              :showColliContent="false"
              :showColliAmount="showColliAmount"
              :showColliDescription="false"
              :showCustoms="false"
              :removable="shipmentPackages.length > 1"
              :dgTypeShownOnPackageCustomId="dgTypeShownOnPackageCustomId"
              :useContentOnShipmentLevel="useContentOnShipmentLevel"
              @removeLoad="removePackage(index)"
              @activePackageGoodsType="updateGoodsType($event, index)"
              @packagingTypeChange="packagingTypeChange(index)"
              @packagingTypeOptionChange="packagingTypeOptionChange(index)"
              @dgTypeChanged="dgTypeChanged($event, index)"
            />
          </div>
        </div>

        <div>
          <Btn
            @click.native="addColliItem"
            class="brand text-center"
            :icon="{
                name: 'plus',
                size: '18',
              }"
            :btnText="`${$i18n.t('add_goods_btn', {index: shipmentPackages.length + 1 })}`"
          />
        </div>
        <div v-if="showDangerousGoods || show_has_temperature" class="m-t-40">
          <ShipmentContentBlock
            v-if="showDangerousGoods && useContentOnShipmentLevel"
            v-model="shipmentPackages[0]"
            :showTemperature="show_has_temperature"
            :showDangerousGoods="showDangerousGoods"
            :showOnlyDescription="false"
            :isQuoteMode="true"
            :isCustomsInvoiceUploaded="!!invoiceFiles"
            :customId="`shipment-content`"
            :showOrigin="showOrigin"
            :showCustoms="showCustoms"
            :showColliContent="showCustoms || systemShowColliContent"
            :showColliAmount="showColliAmount"
            :showColliDescription="showColliDescription"
            :isShipmentInEdit="get_shipment_editing_mode"
            :useContentOnShipmentLevel="useContentOnShipmentLevel"
            :dgTypeShownOnPackageCustomId="dgTypeShownOnPackageCustomId"
            @toggleUseContentOnShipmentLevel="toggleUseContentOnShipmentLevel"
            @packagingTypeChange="packagingTypeChange(0)"
            @packagingTypeOptionChange="packagingTypeOptionChange(0)"
            @dgTypeChanged="dgTypeChanged($event, 0)"
          />
        </div>
      </div>
    </div>
    <!-- Original Booking Form -->
    <div v-else>
    <div  class="m-b-50" style="display: grid; grid-template-columns: minmax(0,1fr) auto minmax(0,1fr); align-items: start;">
      <div class="text-box w-100">
        <h2 class="m-b-20 section-title">{{ $t('Where do you ship from') }}</h2>
        <div class="row">
          <div class="col-xs-12">
            <div class="card book-shipment-address-card">
              <div class="m-b-40">
                <div class="radio-label">{{ $t('shipper_type') }}</div>
                <div class="m-b-input radio-group">
                  <Radio
                    :name="'shipperType'"
                    :text="$t('LBL_COMPANY')"
                    :value="'company'"
                    :checked="shipperType === 'company'"
                    @input="onChangeShipperType"
                  />
                  <Radio
                    :name="'shipperType'"
                    :text="$t('LBL_PRIVATE')"
                    :value="'private'"
                    :checked="shipperType === 'private'"
                    @input="onChangeShipperType"
                  />
                </div>
                <div class="row m-b-input">
                  <div class="col-xs-6">
                    <InputSelect
                      :label="$t('Shipper')"
                      v-model="shipper"
                      @change="checkForForeignShipper"
                      :countryFlag="true"
                      :options="shipperOptions"
                      :disabled="!!get_user.lock_sender"
                    />
                  </div>
                  <div class="col-xs-3" v-if="showCustoms">
                    <InputText
                      v-model="fromData.vat"
                      label="EORI"
                      :rules="{required: false}"
                      :disabled="!foreignShipper"
                    />
                  </div>
                  <div :class="showCustoms ? 'col-xs-3' : 'col-xs-6'">
                    <InputText
                      v-cloak
                      v-model="fromData.reference"
                      :label="$t('reference')"
                      :rules="{required: isSenderReferenceRequired}"
                    />
                  </div>
                </div>
                <div class="row m-b-input">
                  <div class="col-xs-6" v-if="!fromData.shipFromPrivateResident">
                    <AddressBookPicker
                      :label="$t('company')"
                      :rules="{required: false }"
                      placeholder=""
                      search-field="company_name"
                      mode="field"
                      :disable-search="!!fromData.attention || !!fromAddress.address_1"
                      template="{company_name} ({name}) <br> {address_1}, {post_code} {city}"
                      @addressSelected="changeAddress('from', $event)"
                      @addressBookValChanged="fromData.company = $event"
                      :disabled="!foreignShipper"
                      v-model="fromData.company"
                    />
                  </div>
                  <div :class="fromData.shipFromPrivateResident ? 'col-xs-12' : 'col-xs-6'">
                    <AddressBookPicker
                      :label="$t('att.')"
                      :rules="{required: true }"
                      placeholder=""
                      search-field="name"
                      mode="field"
                      :disable-search="!!fromData.company || !!fromAddress.address_1"
                      template="{name} ({company_name}) <br> {address_1}, {post_code} {city}"
                      @addressSelected="changeAddress('from', $event)"
                      @addressBookValChanged="fromData.attention = $event"
                      v-model="fromData.attention"
                    />
                  </div>
                </div>
                <AddressPicker
                  class="m-b-input"
                  :disabled="!foreignShipper"
                  :label="$t('address_1')"
                  placeholder="Search address"
                  :disable-search="!!fromData.company || !!fromData.attention"
                  @addressSelected="changeAddress('from', $event)"
                  v-model="fromAddress"
                />
                <div class="row">
                  <div class="col-xs-6">
                    <PhoneSelect key="fromPhone" v-model="fromData.phone" :rules="{required: isPhoneRequired}"/>
                  </div>
                  <div class="col-xs-6">
                    <InputText
                      v-model="fromData.email"
                      label="Email"
                      :rules="{required: isEmailRequired, email: isEmailRequired}"
                    />
                  </div>
                </div>
              </div>
              <div :class="!foreignShipper ? 'm-b-20':''">
                <div class="radio-label">{{ $t('shipping_by') }}</div>
                <div class="radio-group" :class="toWaybill ? 'm-b-30' : ''">
                  <Radio
                    :name="'senderHandlingType'"
                    :text="$t('pickup_at_shipper')"
                    :value="1"
                    :checked="parseInt(senderHandlingType) === 1"
                    @input="onSenderHandlingTypeChange"
                  />
                  <Radio
                    :name="'senderHandlingType'"
                    :text="$t('other_pickup_address')"
                    :value="2"
                    :checked="parseInt(senderHandlingType) === 2"
                    @input="onSenderHandlingTypeChange"
                  />
                  <Radio
                    :name="'senderHandlingType'"
                    :text="$t('manual_handover_to_carrier')"
                    :value="3"
                    :checked="parseInt(senderHandlingType) === 3"
                    @input="onSenderHandlingTypeChange"
                  />
                </div>
                <!-- PICKUP ADDRESS BOX (OLD WAYBILL NOW IS USED FOR OTHER PICKUP ADDRESS) -->
                <div v-if="toWaybill">
                  <div class="row">
                    <div class="col-xs-12">
                  <InputSelect
                    :label="$t('pickup_address')"
                    v-model="waybillShipper"
                    @change="changeWaybillAddressShipper"
                    :options="shipperOptions"
                  />
                      </div>
                    </div>
                  <div class="row m-t-20 m-b-20" v-if="toWaybill && !waybillShipper">
                    <div class="col-xs-6">
                      <AddressBookPicker
                        :label="$t('company')"
                        :rules="{required: false }"
                        placeholder=""
                        search-field="company_name"
                        mode="field"
                        template="{company_name} ({name}) <br> {address_1}, {post_code} {city}"
                        :disable-search="!!waybillData.attention || !!waybillAddress.address_1"
                        @addressSelected="changeAddress('waybill', $event)"
                        @addressBookValChanged="waybillData.company = $event"
                        @additionalInfoSelected="handleAdditionalInfoSelected"
                        v-model="waybillData.company"
                      />
                    </div>
                    <div class="col-xs-6">
                      <AddressBookPicker
                        :label="$t('att.')"
                        :rules="{required: true }"
                        placeholder=""
                        search-field="name"
                        mode="field"
                        :disable-search="!!waybillData.company || !!waybillAddress.address_1"
                        template="{name} ({company_name}) <br> {address_1}, {post_code} {city}"
                        @addressSelected="changeAddress('waybill', $event)"
                        @addressBookValChanged="waybillData.attention = $event"
                        @additionalInfoSelected="handleAdditionalInfoSelected"
                        v-model="waybillData.attention"
                      />
                    </div>
                  </div>
                  <AddressPicker
                    class="m-b-20"
                    v-if="toWaybill && !waybillShipper"
                    :label="$t('address_1')"
                    @addressSelected="changeAddress('waybill', $event)"
                    v-model="waybillAddress"
                    placeholder="Search address"
                    :disable-search="!!waybillData.company || !!waybillData.attention"
                  />
                  <div class="row" v-if="toWaybill && !waybillShipper">
                    <div class="col-xs-6">
                      <PhoneSelect v-model="waybillData.phone" :rules="{required: isPhoneRequired}"/>
                    </div>
                    <div class="col-xs-6">
                      <InputText
                        v-model="waybillData.email"
                        label="Email"
                        :rules="{required: isEmailRequired}"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="m-t-30 m-b-20" v-if="foreignShipper">
                <Toggle
                  class="m-r-10"
                  id="saveShipperLocation"
                  :label="$t('save_shipper_location')"
                  v-model="saveShipperLocation"
                />
                {{ $t('save_shipper_location') }}
              </div>
              <div class="clear-float" style="margin-top: auto">
                <Btn
                  @click.native="clearFromFields('to')"
                  class="gray float-left m-r-20"
                  :icon="{
                    name: 'deleteForever',
                    size: '18',
                  }"
                  :btnText="$t('Clear all')"
                />
              </div>
              <div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="display: flex; align-items: center; align-self: center; justify-self: center">
        <div @click="swapData" class="m-l-20 m-r-20 button-bar shadowed flex-column p-10 f-s-10">
          <Icon
            name="swapHorizontal"
            size="32"
          />
          <div style="display: block">{{ $t('LBL_SWAP').toUpperCase() }}</div>
        </div>
      </div>
      <div class="text-box w-100">
        <h2 class="m-b-20 section-title">{{ $t('Where do you ship to') }}</h2>
        <div class="row">
          <div class="col-xs-12">
            <div class="card book-shipment-address-card">
              <div>
                <div class="radio-label">{{ $t('receiver_type')}}</div>
                <div class="m-b-input radio-group">
                  <Radio
                    :name="'receiverType'"
                    :text="$t('LBL_COMPANY')"
                    :value="'company'"
                    :checked="receiverType === 'company'"
                    @input="onChangeReceiverType"
                  />
                  <Radio
                    :name="'receiverType'"
                    :text="$t('LBL_PRIVATE')"
                    :value="'private'"
                    :checked="receiverType === 'private'"
                    @input="onChangeReceiverType"
                  />
                </div>
                <div class="row m-b-input">
                  <div class="col-xs-6">
                    <InputSelect
                      :label="$t('Receiver')"
                      v-model="receiver"
                      @change="setReceiverData"
                      :countryFlag="true"
                      :options="shipperOptions"
                      :disabled="!!get_user.lock_receiver"
                    />
                  </div>
                  <div class="col-xs-3" v-if="showCustoms">
                    <InputText
                      v-model="toData.vat"
                      label="EORI"
                      :rules="{required: false}"
                      :disabled="!!receiver"
                    />
                  </div>
                  <div :class="showCustoms ? 'col-xs-3' :  'col-xs-6'">
                    <InputText
                      v-model="toData.reference"
                      :label="$t('reference')"
                      :rules="{required: isReceiverReferenceRequired}"
                    />
                  </div>
                </div>
                <div class="row m-b-input">
                  <div class="col-xs-6" v-if="!toData.shipToPrivateResident">
                    <AddressBookPicker
                      :label="$t('company')"
                      :rules="{required: true }"
                      placeholder=""
                      search-field="company_name"
                      mode="field"
                      template="{company_name} ({name}) <br> {address_1}, {post_code} {city}"
                      :disable-search="!!toData.attention || !!toAddress.address_1"
                      @addressSelected="changeAddress('to', $event)"
                      @addressBookValChanged="toData.company = $event"
                      @additionalInfoSelected="handleAdditionalInfoSelected"
                      :disabled="!!receiver"
                      v-model="toData.company"
                    />
                  </div>
                  <div :class="toData.shipToPrivateResident ? 'col-xs-12' : 'col-xs-6'">
                    <AddressBookPicker
                      :label="$t('att.')"
                      :rules="{required: !! toData.shipToPrivateResident}"
                      placeholder=""
                      search-field="name"
                      mode="field"
                      :disable-search="!!toData.company || !!toAddress.address_1"
                      template="{name} ({company_name}) <br> {address_1}, {post_code} {city}"
                      @addressSelected="changeAddress('to', $event)"
                      @addressBookValChanged="toData.attention = $event"
                      @additionalInfoSelected="handleAdditionalInfoSelected"
                      v-model="toData.attention"
                    />
                  </div>
                </div>
                <AddressPicker
                      class="m-b-input"
                      :label="$t('address_1')"
                      placeholder="Search address"
                      :disable-search="!!toData.company || !!toData.attention"
                      @addressSelected="changeAddress('to', $event)"
                      @additionalInfoSelected="handleAdditionalInfoSelected"
                      :disabled="!!receiver"
                      v-model="toAddress"
                    />

                <div class="row">
                  <div class="col-xs-6">
                    <PhoneSelect key="toPhone" v-model="toData.phone" :rules="{required:isPhoneRequired}"/>
                  </div>
                  <div class="col-xs-6">
                    <InputText
                      v-model="toData.email"
                      label="Email"
                      :rules="{required: isEmailRequired, email: isEmailRequired}"
                    />
                  </div>
                </div>
                <!--  CUSTOMS DATA (WHEN RECEIVER DIFFER FROM BUYER) -->
                <div class="m-t-40">
                  <div class="radio-label">{{ $t('delivery_to')}}</div>
                  <div class="radio-group" :class="isBuyerDifferentFromReceiver ? 'm-b-30' : ''">
                    <Radio
                      :name="'receiverHandlingType'"
                      :text="$t('receiver_address')"
                      :value="1"
                      :checked="parseInt(receiverHandlingType) === 1"
                      @input="onReceiverHandlingTypeChange"
                    />
                    <Radio
                      :name="'receiverHandlingType'"
                      :text="$t('service_point')"
                      :value="2"
                      :checked="parseInt(receiverHandlingType) === 2"
                      @input="onReceiverHandlingTypeChange"
                    />
<!--                    <Radio-->
<!--                      :name="'receiverHandlingType'"-->
<!--                      :text="$t('airport')"-->
<!--                      :value="3"-->
<!--                      :checked="parseInt(receiverHandlingType) === 3"-->
<!--                      @input="onReceiverHandlingTypeChange"-->
<!--                    />-->
                  </div>
                  <div class="m-b-20 m-t-30">
                    <Toggle
                      class="m-r-10"
                      id="customsAddress"
                      :label="$t('buyer_is_different_from_receiver')"
                      v-model="isBuyerDifferentFromReceiver"
                    />
                    {{ $t('use_different_buyer_address') }}
                  </div>
                  <div v-if="parseInt(receiverHandlingType) === 2">
                    <message style="margin-bottom: 25px; margin-top: 20px; padding: 20px" name="warning" :data="data={data: $t('service_point_select_will_be_on_product'), type:'validation'}"></message>
                  </div>
                  <div class="col-xs-12 m-b-20" v-if="isBuyerDifferentFromReceiver">
                    <div class="row m-b-20">
                      <div class="col-xs-6">
                        <InputText
                          v-model="customsAddressData.vat"
                          label="EORI"
                        />
                      </div>
                      <div class="col-xs-6">
                        <InputText
                          v-model="customsAddressData.reference"
                          :label="$t('reference')"
                        />
                      </div>
                    </div>
                    <div class="row m-b-20">
                      <div class="col-xs-6">
                        <AddressBookPicker
                          :label="$t('company')"
                          :rules="{required: false }"
                          placeholder=""
                          search-field="company_name"
                          mode="field"
                          template="{company_name} ({name}) <br> {address_1}, {post_code} {city}"
                          :disable-search="!!customsAddressData.attention || !!customsAddress.address_1"
                          @addressSelected="changeAddress('customs', $event)"
                          @addressBookValChanged="customsAddressData.company = $event"
                          @additionalInfoSelected="handleAdditionalInfoSelected"
                          v-model="customsAddressData.company"
                        />
                      </div>
                      <div class="col-xs-6">
                        <AddressBookPicker
                          :label="$t('att.')"
                          :rules="{required: false }"
                          placeholder=""
                          search-field="name"
                          mode="field"
                          :disable-search="!!customsAddressData.company || !!customsAddress.address_1"
                          template="{name} ({company_name}) <br> {address_1}, {post_code} {city}"
                          @addressSelected="changeAddress('customs', $event)"
                          @addressBookValChanged="customsAddressData.attention = $event"
                          @additionalInfoSelected="handleAdditionalInfoSelected"
                          v-model="customsAddressData.attention"
                        />
                      </div>
                    </div>
                    <AddressPicker
                      class="m-b-input"
                      :label="$t('address_1')"
                      placeholder="Search address"
                      :disable-search="!!customsAddressData.company || !!customsAddressData.attention"
                      @addressSelected="changeAddress('customs', $event)"
                      v-model="customsAddress"
                    />
                    <div class="row">
                      <div class="col-xs-6">
                        <PhoneSelect v-model="customsAddressData.phone"/>
                      </div>
                      <div class="col-xs-6">
                        <InputText
                          v-model="customsAddressData.email"
                          label="Email"
                        />
                      </div>
                    </div>
                  </div>

                </div>
              </div>
              <div class="clear-float" style="margin-top: auto">
                <Btn
                  @click.native="clearAddressData('to')"
                  class="gray float-left m-r-20"
                  :icon="{
                    name: 'deleteForever',
                    size: '18',
                  }"
                  :btnText="$t('Clear all')"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
<!--    <div class="separator"></div>-->
    <!-- CONTENTT -->
    <ShipmentContentBlock
      v-model="shipmentPackages[0]"
      :showTemperature="show_has_temperature"
      :showDangerousGoods="showDangerousGoods"
      :showOnlyDescription="false"
      :isCustomsInvoiceUploaded="!!invoiceFiles"
      :customId="`shipment-content`"
      :showOrigin="showOrigin"
      :showCustoms="showCustoms"
      :showColliContent="showCustoms || systemShowColliContent"
      :showColliAmount="showColliAmount"
      :showColliDescription="showColliDescription"
      :isShipmentInEdit="get_shipment_editing_mode"
      :useContentOnShipmentLevel="useContentOnShipmentLevel"
      :dgTypeShownOnPackageCustomId="dgTypeShownOnPackageCustomId"
      @toggleUseContentOnShipmentLevel="toggleUseContentOnShipmentLevel"
      @packagingTypeChange="packagingTypeChange(0)"
      @packagingTypeOptionChange="packagingTypeOptionChange(0)"
      @dgTypeChanged="dgTypeChanged($event, 0)"
    />
    <!-- END CONTENTT -->
    <!-- GOODS -->
    <div class="text-box">
      <div class="row" v-for="(item, index) in shipmentPackages" :key="`${item.goodsTypeName}-${index}`">
        <div v-if="item.goodsType === 2 && get_parcel_types != null" class="col-xs-12">
          <DocumentBlock
            :label="`#${index+1} - ${$t(item.goodsTypeName)}`"
            v-model="shipmentPackages[index]"
            :indexNo="`${index}`"
            :removable="shipmentPackages.length > 1"
            :showColliAmount="showColliAmount"
            :customId="`palletID-${index}`"
            @removeDocument="removePackage(index)"
            @activePackageGoodsType="updateGoodsType($event, index)"/>
        </div>
        <div v-if="item.goodsType === 1 && get_parcel_types != null" class="col-xs-12">
          <ParcelBlock
            v-model="shipmentPackages[index]"
            :indexNo="`${index}`"
            :showTemperature="show_has_temperature"
            :showDangerousGoods="showDangerousGoods"
            :showOnlyDescription="false"
            :isCustomsInvoiceUploaded="!!invoiceFiles"
            :customId="`parcelID-${index}`"
            :label="`#${index+1} - ${$t(item.goodsTypeName)}`"
            :removable="shipmentPackages.length > 1"
            :showOrigin="showOrigin"
            :showCustoms="showCustoms"
            :showColliContent="showColliContent[index] ? showColliContent[index] : false"
            :showColliAmount="showColliAmount"
            :showColliDescription="showColliDescription"
            :isShipmentInEdit="get_shipment_editing_mode"
            :useContentOnShipmentLevel="useContentOnShipmentLevel"
            :dgTypeShownOnPackageCustomId="dgTypeShownOnPackageCustomId"
            @removeParcel="removePackage(index)"
            @activePackageGoodsType="updateGoodsType($event, index)"
            @packagingTypeChange="packagingTypeChange(index)"
            @packagingTypeOptionChange="packagingTypeOptionChange(index)"
            @dgTypeChanged="dgTypeChanged($event, index)"
          />
        </div>
        <div v-if="item.goodsType === 3 && get_parcel_types != null" class="col-xs-12">
          <PalleteBlock
            v-model="shipmentPackages[index]"
            :indexNo="`${index}`"
            :showTemperature="show_has_temperature"
            :showDangerousGoods="showDangerousGoods"
            :isCustomsInvoiceUploaded="!!invoiceFiles"
            :showOnlyDescription="false"
            :label="`#${index+1} - ${$t(item.goodsTypeName)}`"
            :customId="`palletID-${index}`"
            :removable="shipmentPackages.length > 1"
            :showOrigin="showOrigin"
            :showCustoms="showCustoms"
            :showColliContent="showColliContent[index] ? showColliContent[index] : false"
            :showColliAmount="showColliAmount"
            :showColliDescription="showColliDescription"
            :dgTypeShownOnPackageCustomId="dgTypeShownOnPackageCustomId"
            :useContentOnShipmentLevel="useContentOnShipmentLevel"
            @removePallet="removePackage(index)"
            @activePackageGoodsType="updateGoodsType($event, index)"
            @palletExchangeUpdated="palletExchangeServiceCheck"
            @packagingTypeChange="packagingTypeChange(index)"
            @packagingTypeOptionChange="packagingTypeOptionChange(index)"
            @dgTypeChanged="dgTypeChanged($event, index)"
          />
        </div>
        <div v-if="item.goodsType === 4  && get_parcel_types != null" class="col-xs-12">
          <LoadBlock
            v-model="shipmentPackages[index]"
            :showTemperature="show_has_temperature"
            :showDangerousGoods="showDangerousGoods"
            :isCustomsInvoiceUploaded="!!invoiceFiles"
            :showOnlyDescription="false"
            :customId="`loadID-${index}`"
            :label="`#${index+1} - ${$t(item.goodsTypeName)}`"
            :showOrigin="showOrigin"
            :showColliContent="showColliContent[index] ? showColliContent[index] : false"
            :showColliAmount="showColliAmount"
            :showColliDescription="showColliDescription"
            :showCustoms="showCustoms"
            :removable="shipmentPackages.length > 1"
            :dgTypeShownOnPackageCustomId="dgTypeShownOnPackageCustomId"
            :useContentOnShipmentLevel="useContentOnShipmentLevel"
            @removeLoad="removePackage(index)"
            @activePackageGoodsType="updateGoodsType($event, index)"
            @packagingTypeChange="packagingTypeChange(index)"
            @packagingTypeOptionChange="packagingTypeOptionChange(index)"
            @dgTypeChanged="dgTypeChanged($event, index)"
          />
        </div>
      </div>
      <div>
        <Btn
          @click.native="addColliItem"
          class="brand text-center"
          :icon="{
              name: 'plus',
              size: '18',
            }"
          :btnText="`${$i18n.t('add_goods_btn', {index: shipmentPackages.length + 1 })}`"
        />
      </div>
    </div>
    <div class="separator"></div>
    <!-- CUSTOM INFORMATION -->
    <!-- PAYMENT TERMS -->
    <AdditionalInformation
      v-if="show_freight_paid_by || show_incoterms || showCustoms || alwaysShowDocumentUpload"
      v-model="customsData"
      @incotermsServicesUpdate="updateIncotermsServices"
      @file-uploaded="addFiles"
      @document-type-changed="updateDocumentType"
      @selected-info-update="updateSelectedInfo"
      @additional-info-update="updateAdditionalInfo"
      :invoiceFiles="invoiceFiles"
      :documentType="customsData.documentType"
      :selected-info-items="selectedInfoItems"
      :additional-info="{eori, eccn, customsAdditionalInfoText, mrn, eeiitn: {eei: eeiitn.eei, tinType: eeiitn.tinType, tinNumber: eeiitn.tinNumber}, invoiceType}"
      :showFreightBy="show_freight_paid_by"
      :availableIncoterms="availableIncoterms"
      :showIncoterms="show_incoterms"
      :showCustoms="showCustoms"
      :forceShowUploadForm="alwaysShowDocumentUpload"
    />
    <div class="separator" v-if="custom_tag_json.length > 0 && (show_freight_paid_by || show_incoterms)"></div>
    <!-- TAGS -->
    <div class="text-box" v-if="custom_tag_json.length > 0">
      <h2 class="m-b-20 section-title">{{ $t('Custom tags') }}</h2>
      <div class="card">
        <div class="row">
          <InputText
            class="m-b-20"
            :class="colSize"
            v-for="(tag, index) in custom_tag_json" :key="`tag-${index}`"
            :label="tag.custom_tag_name"
            :rules="{required: tag.custom_tag_is_required}"
            v-model="custom_tag_json[index].custom_tag_value" />
        </div>
      </div>
    </div>
    <!-- ADDITIONAL SERVICES -->
    </div>
      <div class="separator"  v-show="isServicesBlockActive"></div>
    <div class="text-box" v-show="isServicesBlockActive">
      <AdditionalServices
        :isDroppoint="parseInt(receiverHandlingType) === 2"
        :pickupLocationId="waybillShipper ? waybillShipper : shipper"
        :shipperAsSenderID="shipper != null ? shipper : '0'"
        :shippingDate="shippingDate"
        :pickupDate="shippingDate"
        :selectedProductId="selectedProduct"
        :editShipmentDroppointNo="editShipmentDroppointNo"
        :apiFeeIds="feeIdsJson"
        :apiActiveServices="active_services_json"
        :additionalServicesFieldsData="additionalServicesFieldsData"
        :observableObject="observableObject"
        :dataForProducts="dataForProducts"
        :senderHandlingType="senderHandlingType"
        @set-shipping-date="setShippingDate"
        :fromReferenceListener="{
          ref: fromData.reference,
          required: isSenderReferenceRequired,
        }"
        :toReferenceListener="{
          ref: toData.reference,
          required: isReceiverReferenceRequired,
        }"
        :customsData="customsData"
        :companyFromListener="fromData.company"
        :companyToListener="toData.company"
        :shipToPrivateResident="toData.shipToPrivateResident"
        @available-incoterms="availableIncoterms = $event"
        @bookShipment="bookShipment"
        :showColliContent="showColliContent"
        :incotermServiceIds="incotermServices"
        :externallyInjectedServiceIds="externallyInjectedServices"
        :pickupTimeFrom="pickupTimeFrom"
        :pickupTimeUntil="pickupTimeUntil"
        :pickupDriverNote="pickupDriverNote"
        :disable-book-button="bookingType === 'quote'"
      />
    </div>
      <div v-if="!isServicesBlockActive  && bookingType !== 'quote'" class="m-t-20">
        <message name="warning" :data="data={data:isServicesActiveMessage, type:'validation'}"></message>
      </div>
    <div class="m-b-40"></div>
    </div>
    <Popup
      v-if="showShipmentPopup"
      :showConfirmButton=false
      :showPrintButton=showBookingPrintButton
      :showPreviewButton=showViewShipmentButton
      :showDownloadButton=showDownloadShippingLabelsButton
      :showDownloadDGButton=showDownloadDGButton
      :showDownloadEODButton=showDownloadEODButton
      cancelText="close"
      downloadText="Download waybills"
      downloadDGText="Download DGD"
      downloadEODText="Download EOD"
      @print="printShipment"
      @download="downloadShipment"
      @downloadDG="downloadDGFile"
      @downloadEOD="downloadEOD"
      @redirect="redirectFromShipment"
      @cancel="closeShipmentPopup">
      <template v-slot:header>
        <h2>{{ getWaybillText }}</h2>
      </template>
      <div>
        <div class="text-center" v-if="!isPDFGenerated">
          <Icon
            class="icon"
            name="animation"
            size="64" />
          <h2 class="m-b-30">{{ $t('Generating waybills') }}</h2>
        </div>
        <div v-if="isPDFGenerated">
          <pdf
            :numPages="numPages"
            :src="pdfFilePath"
            :rotate="getRotationDegree"
          ></pdf>
        </div>
        <iframe
          style="display: none;"
          ref="printPDF"
          id="printPDF"
          name="printPDF"
          width="100%"
          height="600px" />
        <a
          style="display: none"
          :download="pdfName"
          ref="downloadPDF"
          :href="pdfPath" />
        <a
          style="display: none"
          :download="`dg_${shipmentId}`"
          ref="downloadDgRef"
          :href="dgPdfPath" />
        <a
          style="display: none"
          :download="`${downloadEodName}`"
          ref="downloadEODPDF"
          :href="eodPdfPath" />
      </div>
    </Popup>
    <Popup
      v-if="showUnapprovedPopup"
      :showConfirmButton=false
      @cancel="closeUnapprovedPopup"
      cancelText="close"
    >
      <template v-slot:header>
        <h2>{{ $t('Shipment waiting for approval') }}</h2>
      </template>
      <div class="popup-info-text">
          {{ $t('Shipment_approval_text') }}
      </div>
    </Popup>
  </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import pdf from '@/components/global/pdfWrapper/index';
import mixin from '@/mixins/mixins.js';
import shipmentMixin from '@/mixins/shipment.js';
import Btn from '@/components/elements/buttons';
import AddressPicker from '@/components/global/addressPicker/index.vue';
import InputText from '@/components/elements/inputs/text.vue';
import Calendar from '@/components/elements/inputs/calendar.vue';
import InputSelect from '@/components/elements/inputs/select.vue';
import PhoneSelect from '@/components/elements/inputs/phone.vue';
import Toggle from '@/components/elements/inputs/toggle.vue';
import Popup from '@/components/global/popup';
import Radio from "@/components/elements/inputs/radio.vue";

import DocumentBlock from '@/components/shipments/documentBlock.vue';
import ParcelBlock from '@/components/shipments/parcelBlock.vue';
import PalleteBlock from '@/components/shipments/palleteBlock.vue';
import LoadBlock from '@/components/shipments/loadBlock.vue';
import AdditionalServices from '@/components/shipments/services.vue';
import ShipmentContentBlock from "@/components/shipments/shipmentContentBlock.vue";
import AdditionalInformation from "@/components/shipments/additionalInformation.vue";

import stateList from '@/data/state.js';
import countryList from "@/data/country";
import i18n from "@/i18n";
import SubaccountSelect from "@/components/elements/inputs/subaccountSelect.vue";
import AddressBookPicker from "../../components/global/addressBookPicker/index.vue";
import {DateTime} from "luxon";
import dateMixin from '@/mixins/date'
import CountrySelect from "../../components/elements/inputs/countrySelect.vue";
import TogglePill from "../../components/elements/inputs/togglePill.vue";

function initialState() {
  return {
    bookingCompleted: false,
    shipperType: 'company',
    receiverType: 'company',
    senderHandlingType: 1,
    receiverHandlingType: 1,
    showSaveDialog: false,
    pendingNavigation: null,
    useContentOnShipmentLevel: true,
    shipmentTraceNo: '',
    pickupDriverNote: '',
    pickupTimeFrom: '',
    pickupTimeUntil: '',
    pickupProductId: '',
    draftError: null,
    // Globals
    dgType: null,
    dgTypeShownOnPackageCustomId: '',
    dangerousGoodsLoaded: false,
    bookingSubaccount: null,
    showColliAmount: false,
    showColliContent: [],
    systemShowColliContent: false,
    alwaysShowDocumentUpload: false,
    showInfoBox: false,
    isReturn: false,
    editShipmentDroppointNo: '',
    shippingAgentName: '',
    showUnapprovedPopup: false,
    availableIncoterms: [],
    draftShippmentId: '',
    isSenderReferenceRequired: false,
    isReceiverReferenceRequired: false,
    isPhoneRequired: true,
    isEmailRequired: true,
    shippingDate: '',
    foreignShipper: true,
    shipper: '',
    saveShipperLocation: false,
    receiver: null,
    shipperOptions: [],
    swapped: false,
    isShipperInFrom: false,
    cachedShipper: '',
    // SENDER
    fromAddress: {
      address_1: '',
      address_2: '',
      country_id: '',
      post_code: '',
      city: '',
      state: '',
    },
    fromData: {
      reference: '',
      company: '',
      attention: '',
      email: '',
      vat: '',
      shipToPrivateResident: false,
      shipFromPrivateResident: false,
      phone: {
        number: '',
        country: '',
      },
    },
    toWaybill: false,
    waybillShipper: null,
    //Waybill address and data are now used to store pickup address data
    waybillAddress: {
      address_1: '',
      address_2: '',
      country_id: '',
      post_code: '',
      city: '',
      state: '',
    },
    waybillData:{
      company: '',
      attention: '',
      email: '',
      phone: {
        number: '',
        country: '',
      },
    },
    // CUSTOMER - TO DATA
    toAddress: {
      address_1: '',
      address_2: '',
      country_id: '',
      post_code: '',
      city: '',
      state: '',
    },
    toData: {
      company: '',
      shipToPrivateResident: false,
      shipFromPrivateResident: false,
      reference: '',
      attention: '',
      email: '',
      vat: '',
      phone: {
        number: '',
        country: '',
      },
    },
    // Used on customs invoice
    isBuyerDifferentFromReceiver: false,
    customsAddress: {
      address_1: '',
      address_2: '',
      country_id: '',
      post_code: '',
      city: '',
      state: '',
    },
    customsAddressData: {
      company: '',
      attention: '',
      email: '',
      reference: '',
      vat: '',
      phone: {
        number: '',
        country: '',
      },
    },
    // CUSTOMS INFORMATION
    additionalInfoOptions: [
      {
        text: 'ECCN',
        value: '2',
      },
      {
        text: 'EEI',
        value: '3',
      },
      {
        text: 'TEXT',
        value: '22',
      },
      {
        text: 'MRN',
        value: '4',
      },
    ],
    selectedInfoItems: [],
    eori: '',
    eccn: '',
    customsAdditionalInfoText: '',
    mrn: '',
    eeiitn: {
      eei: '',
      tinType: '',
      tinNumber: '',
    },
    // UPLOAD BOX
    showCustoms: false,
    isActiveCustom: true,
    invoiceFiles: null,
    invoiceFileName: '',
    invoiceType: '2',
    invoiceTypeOptions: [
      { text: `${i18n.t('Sample')}`, value: 1},
      { text: `${i18n.t('Sale')}`, value: 2},
      { text: `${i18n.t('Gift')}`, value: 3},
      { text: `${i18n.t('Return_1')}`, value: 4},
      { text: `${i18n.t('Repair')}`, value: 5},
      { text: `${i18n.t('Temporary export')}`, value: 6},
      { text: `${i18n.t('Exhibition goods')}`, value: 7},
      { text: `${i18n.t('Testing analysis')}`, value: 8},
    ],
    tinTypeOptions: [
      { text: `${i18n.t('BUSINESS_NATIONAL')}`, value: 1},
      { text: `${i18n.t('BUSINESS_STATE')}`, value: 2},
      { text: `${i18n.t('BUSINESS_UNION')}`, value: 3},
      { text: `${i18n.t('PERSONAL_NATIONAL')}`, value: 4},
      { text: `${i18n.t('PERSONAL_STATE')}`, value: 5},
    ],
    // PAYMENT TERMS BOX
    customsData: {
      goods_incoterm: 'DAP',
      duty_paid_by: 1,
      duty_payer_account_no: '',
      freight_paid_by: 1,
      freight_payer_account_no: '',
      freight_payer_id: '',
      clearance_by: 'carrier',
      broker_id: null,
      documentType: 'CINV',
    },
    // GOODS
    showOrigin: true,
    activeGoodsTypes: [],
    shipmentPackages: [],
    defaultPackageBlocks: {
      parcel: {
        goodsTypeName: 'Parcel',
        goodsType: 1,
        colli: 1,
        description: '',
        parcelType: this?.get_user?.parcel_package_id,
        packagingName: '',
        colliWeight: {
          value: '',
          unit: 'kg',
        },
        dimensions: {
          width: {
            value: '',
            disabled: false,
          },
          height: {
            value: '',
            disabled: false,
          },
          length: {
            value: '',
            disabled: false,
          },
          dimensionsType: '',
        },
        isTemperature: false,
        minTemperature: '',
        maxTemperature: '',
        content: [
          {
            qty: 1,
            description: '',
            unitWeight: {
              value: '',
              unit: 'kg',
            },
            unitValue: {
              value: '',
              unit: 'dkk',
            },
            hsCode: '',
            origin: '',
          },
        ],
        isDgToggleActive: false,
        qty: 1,
        Q: '',
        packingType: '',
        packingTypeOption: 2,
        isOverpack: 0,
        allPackedInOne: 2,
        iataLimitations: '',
        iataRadioactive: '',
        iataAdditionalInfo: '',
        dangerousGoodsServices: [
          {
            feeWrapperId: null,
            dangerousGoodsId: '',
            nemWeight: {
              unit: 'kg',
              value: null,
            },
            netWeight: {
              unit: 'kg',
              value: null,
            },
            bruttoWeight: {
              unit: 'kg',
              value: null,
            },
            englishTechnicalDesignation: '',
            danishTechnicalDesignation: '',
            iataAutorization: '',
            flashPoint: '',
            segregationGroup: '',
            ems: '',
            notAllInOneQty: '',
            notAllInOneOuterPackaging: '',
            innerPackaging: '',
            innerPackagingQty: '',
            packingInstruction: '',
            isEnvironmentalHazard: false,
            isMarinePollutant: false,
            isLimitedQuantity: false,
            isExceptedQuantity: false
          }
        ]
      },
      document: {
        goodsTypeName: 'Document',
        goodsType: 2,
        colli: 1,
        parcelType: '',
        packagingName: '',
        isTemperature: false,
        colliWeight: {
          value: '',
          unit: 'kg',
        },
        dimensions: {
          width: {
            value: '',
            disabled: false,
          },
          height: {
            value: '',
            disabled: false,
          },
          length: {
            value: '',
            disabled: false,
          },
          dimensionsType: 'cmb',
        },
      },
      pallet: {
        goodsTypeName: 'Pallet',
        goodsType: 3,
        colli: 1,
        description: '',
        palleteType: '',
        palleteExchange: null,
        colliWeight: {
          value: '',
          unit: 'kg',
        },
        dimensions: {
          width: {
            value: '',
            disabled: false,
          },
          height: {
            value: '',
            disabled: false,
          },
          length: {
            value: '',
            disabled: false,
          },
          dimensionsType: 'cm',
        },
        isTemperature: false,
        minTemperature: '',
        maxTemperature: '',
        pallet_stackable_type: 'stackable',
        palletSpace: '',
        palletExchange: null,
        // stackablePallets: true,
        content: [
          {
            qty: 1,
            description: '',
            unitWeight: {
              value: '',
              unit: 'kg',
            },
            unitValue: {
              value: '',
              unit: 'dkk',
            },
            hsCode: '',
            origin: '',
          },
        ],
        isDgToggleActive: false,
        packingType: '',
        packingTypeOption: 2,
        isOverpack: 0,
        allPackedInOne: 2,
        iataRadioactive: '',
        iataLimitations: '',
        iataAdditionalInfo: '',
        dangerousGoodsServices: [
          {
            qty: 1,
            feeWrapperId: null,
            dangerousGoodsId: '',
            nemWeight: {
              unit: 'kg',
              value: null,
            },
            netWeight: {
              unit: 'kg',
              value: null,
            },
            bruttoWeight: {
              unit: 'kg',
              value: null,
            },
            englishTechnicalDesignation: '',
            danishTechnicalDesignation: '',
            iataAutorization: '',
            flashPoint: '',
            segregationGroup: '',
            ems: '',
            notAllInOneQty: '',
            notAllInOneOuterPackaging: '',
            innerPackaging: '',
            innerPackagingQty: '',
            packingInstruction: '',
            isEnvironmentalHazard: false,
            isMarinePollutant: false,
            isLimitedQuantity: false,
            isExceptedQuantity: false
          }
        ]
      },
      load: {
        goodsTypeName: 'Load',
        goodsType: 4,
        colli: 1,
        description: '',
        parcelType: 0, //Unknown packaging
        packagingName: '',
        colliWeight: {
          value: '',
          unit: 'kg',
        },
        dimensions: {
          width: {
            value: '',
            disabled: false,
          },
          height: {
            value: '',
            disabled: false,
          },
          length: {
            value: '',
            disabled: false,
          },
          dimensionsType: '',
        },
        cubicMeter: '',
        loadMeter: '',
        isTemperature: false,
        minTemperature: '',
        maxTemperature: '',
        content: [
          {
            qty: 1,
            description: '',
            unitWeight: {
              value: '',
              unit: 'kg',
            },
            unitValue: {
              value: '',
              unit: 'dkk',
            },
            hsCode: '',
            origin: '',
          },
        ],
        isDgToggleActive: false,
        packingType: '',
        packingTypeOption: 2,
        isOverpack: 0,
        allPackedInOne: 2,
        iataRadioactive: '',
        iataLimitations: '',
        iataAdditionalInfo: '',
        dangerousGoodsServices: [
          {
            qty: 1,
            feeWrapperId: null,
            dangerousGoodsId: '',
            nemWeight: {
              unit: 'kg',
              value: null,
            },
            netWeight: {
              unit: 'kg',
              value: null,
            },
            bruttoWeight: {
              unit: 'kg',
              value: null,
            },
            englishTechnicalDesignation: '',
            danishTechnicalDesignation: '',
            iataAutorization: '',
            flashPoint: '',
            segregationGroup: '',
            ems: '',
            notAllInOneQty: '',
            notAllInOneOuterPackaging: '',
            innerPackaging: '',
            innerPackagingQty: '',
            packingInstruction: '',
            isEnvironmentalHazard: false,
            isMarinePollutant: false,
            isLimitedQuantity: false,
            isExceptedQuantity: false
          }
        ]
      },
    },
    // TAGS
    custom_tag_json: [],
    custom_tag_json_tmp: [],
    // SERVICES AND PRODUCTS
    isServicesActiveMessage: '',
    incotermServices: [],
    palletExchangeServiceId: null,
    externallyInjectedServices: [],
    feeIdsJson: [],
    active_services_json: {},
    selectedProduct: '',
    additionalServicesFieldsData: null,
    //freight_booking_confirmation_no: '',
    // API SERVICES DATA
    apiFeeIds: [],
    apiActiveServices: null,
    // BOOKING
    pdfName: '',
    pdfFile: '',
    pdfPath: '',
    shipmentPopup: false,
    showShipmentPopup: false,
    shipmentId: '',
    isPDFGenerated: false,
    labelImageSource: '',
    pdfFilePath: '',
    numPages: undefined,
    dgFilePath: '',
    dgPdfPath: '',
    eodPdfPath: '',
    downloadEodName: '',
    batchNumber: null,
    // Permissions
    show_has_temperature: true,
    show_dangerous_goods: true, //Overridden by mixin setting taken from user, if false do not use dg
    show_other_shipper_address: true,
    show_freight_paid_by: true,
    show_incoterms: true,
  }
}

export default {
  name: 'Shipments',
  mixins: [mixin, shipmentMixin, dateMixin],
  components: {
    CountrySelect,
    AdditionalInformation,
    AddressBookPicker,
    SubaccountSelect,
    Popup,
    Btn,
    AddressPicker,
    InputSelect,
    InputText,
    Toggle,
    PhoneSelect,
    Radio,
    Calendar,
    AdditionalServices,
    DocumentBlock,
    ParcelBlock,
    PalleteBlock,
    LoadBlock,
    pdf,
    ShipmentContentBlock,
    TogglePill
  },
  data() {
      return {
        bookingType: 'standard',
        originalTrackedState: null,
        trackedKeys: ['toAddress', 'toData'],
        goodsTypeOptions: [
          { text: this.$t('Parcel'), value: 1 },
          { text: this.$t('Document'), value: 2 },
          { text: this.$t('Pallet'), value: 3 },
          { text: this.$t('Load'), value: 4 }
        ],
        isInitialized: false,
        ...initialState()
      }
  },
  created() {
    // Initialize tracked state object with specified keys
    this.initializeTrackedState();
  },
  computed: {
    ...mapGetters([
      'get_shipments_list',
      'get_shipments_count',
      'get_shippers',
      'get_brokers',
      'get_shippers_by_id',
      'get_user',
      'get_pallet_types',
      'get_parcel_types',
      'get_editing_shipment',
      'get_shipment_editing_mode',
      'get_active_subaccount',
      'get_single_shipment',
    ]),
    hasChanges() {
      // Skip comparison if originalTrackedState hasn't been set yet
      if (!this.originalTrackedState) {
        return false;
      }

      // Create clean copies of current values for tracked keys
      const currentState = this.trackedKeys.reduce((acc, key) => {
        acc[key] = _.cloneDeep(this[key]);
        return acc;
      }, {});

      // Custom comparison function for special cases
      const customizer = (value1, value2) => {
        // Handle empty strings vs null/undefined
        if ((value1 === '' && (value2 === null || value2 === undefined)) ||
          (value2 === '' && (value1 === null || value1 === undefined))) {
          return true;
        }

        // Handle numeric strings vs numbers
        if (typeof value1 === 'string' && typeof value2 === 'number') {
          return Number(value1) === value2;
        }
        if (typeof value1 === 'number' && typeof value2 === 'string') {
          return value1 === Number(value2);
        }
      };

      return !_.isEqualWith(currentState, this.originalTrackedState, customizer);
    },
    changedFields() {
      if (!this.hasChanges) {
        return [];
      }

      const differences = [];

      const compareObjects = (obj1, obj2, path = '') => {
        for (const key in obj1) {
          const currentPath = path ? `${path}.${key}` : key;

          if (_.isObject(obj1[key]) && !Array.isArray(obj1[key]) && _.isObject(obj2?.[key])) {
            compareObjects(obj1[key], obj2[key], currentPath);
          } else if (!_.isEqual(obj1[key], obj2?.[key])) {
            differences.push({
              field: currentPath,
              oldValue: obj2?.[key],
              newValue: obj1[key]
            });
          }
        }
      };

      // Compare each tracked key
      this.trackedKeys.forEach(key => {
        const currentValue = _.cloneDeep(this[key]);
        const originalValue = _.cloneDeep(this.originalTrackedState[key]);
        compareObjects({ [key]: currentValue }, { [key]: originalValue });
      });

      return differences;
    },
    buyerIsDifferentFromReceiver() {
      this.isBuyerDifferentFromReceiver = (this.customsAddress.address_1 !== this.customsAddress.address_1);
    },
    showColliDescription() {
      return !this.useContentOnShipmentLevel;
    },
    shipToPrivateAddressToggle() {
      return this.toData.shipToPrivateResident;
    },
    shipFromPrivateAddressToggle() {
      return this.fromData.shipFromPrivateResident;
    },
    useShipmentContentLevelToggle() {
      return this.useContentOnShipmentLevel;
    },
    showBookingPrintButton() {
      return !!this.isPDFGenerated
    },
    showDownloadShippingLabelsButton() {
      return !!this.isPDFGenerated
    },
    showViewShipmentButton() {
      return !!this.isPDFGenerated
    },
    showDownloadDGButton() {
      return !!this.isPDFGenerated && !!this.dgFilePath
    },
    showDownloadEODButton() {
      return !!this.isPDFGenerated
    },
    getWaybillText () {
      if (!this.isPDFGenerated) {
        return this.$t('Generating waybills')
      }
      return `${this.$t('TXT_BOOKING_COMPLETED')} - ${this.shipmentTraceNo}`;
    },
    showDangerousGoods () {
      return this.show_dangerous_goods && this.dangerousGoodsLoaded;
    },
    needApproval() {
      if(parseInt(this.get_user.book_permission_type) === 1 && parseInt(this.get_active_subaccount.book_approval_type) === 1) return false;
      return true;
    },
      getRotationDegree () {
        let degree = 0;
        if (this.shippingAgentName === 'Dao365' && (parseInt(this.get_user.label_format) === 2 || parseInt(this.get_user.label_format) === 3)) {
          degree = 90;
        }
        return degree;
      },
    isServicesBlockActive() {
      if (this.bookingType === 'quote') {
        return this.isQuoteServicesValid;
      }
      return this.isStandardServicesValid;
    },
    isQuoteServicesValid() {
      let result = true;
      this.isServicesActiveMessage = '';

      if (!this.fromAddress.country_id || !this.toAddress.country_id) {
        result = false;
      }
      if (this.postCodeRequired('from') && !this.fromAddress.post_code) {
        result = false;
      }
      if (this.postCodeRequired('to') && !this.toAddress.post_code) {
        result = false;
      }

      // Validate shipment packages
      this.shipmentPackages.forEach((pack) => {
        if (!pack.colli || !pack.dimensions.length.value || !pack.dimensions.width.value
          || !pack.dimensions.height.value || !pack.colliWeight.value) {
          result = false;
        }
      });

      return result;
    },
    isStandardServicesValid() {
      let result = true;
      this.isServicesActiveMessage = `${this.$t('validation_message_services')}: </br></br>`

      if(this.subaccountId == '') {this.isServicesActiveMessage += `&#x2022; ${this.$t('subaccount_id')}</br>`; result = false};
      if(this.shippingDate == '') {this.isServicesActiveMessage += `&#x2022; ${this.$t('ship_date')}</br>`; result = false};
      // Sender
      if(this.fromAddress.country_id == '') {this.isServicesActiveMessage += `&#x2022; ${this.$t('sender_country_id')}</br>`; result = false};
      if(this.postCodeRequired('from') && this.fromAddress.post_code == '') {this.isServicesActiveMessage += `&#x2022; ${this.$t('sender_post_code')}</br>`; result = false};

      if(this.isSenderReferenceRequired){
        if(this.fromData.reference == '' || this.fromData.reference == null ) {this.isServicesActiveMessage += `&#x2022; ${this.$t('sender_reference')}</br>`; result = false};
      }
      // Customer
      if(this.toAddress.country_id == '') {this.isServicesActiveMessage += `&#x2022; ${this.$t('receiver_country_id')}</br>`; result = false};
      if(this.postCodeRequired('to') && this.toAddress.post_code == '') {this.isServicesActiveMessage += `&#x2022; ${this.$t('receiver_post_code')}</br>`; result = false};

      if(this.isReceiverReferenceRequired){
        if(this.toData.reference == '' || this.toData.reference == null) {this.isServicesActiveMessage += `&#x2022; ${this.$t('receiver_reference')}</br>`; result = false};
      }

      // if(this.toAddress.city == '') {this.isServicesActiveMessage += `&#x2022; ${this.$t('receiver_city')}</br>`; result = false};
      // if(this.toAddress.address_1 == '') {this.isServicesActiveMessage += `&#x2022; ${this.$t('receiver_address')}</br>`; result = false};
      // if(this.fromAddress.address_1 == '') {this.isServicesActiveMessage += `&#x2022; ${this.$t('sender_address')}</br>`; result = false};
      // if(this.fromAddress.city == '') {this.isServicesActiveMessage += `&#x2022; ${this.$t('sender_city')}</br>`; result = false};
      // Goods
      // Parcel

      this.shipmentPackages.forEach((parcel, index) => {

        if(parseInt(parcel.goodsType) === 1) {
          let parcelValidation = true;
          let parcelText = `</br>&#x2022; ${this.$t('colli')} ${index + 1}: `;
          if(parcel.colli == '0') {parcelText += `${this.$t('colli_zero_error')}, `; parcelValidation = false};
          if(parcel.colli == '') {parcelText += `${this.$t('colli_empty_error')}, `; parcelValidation = false};
          // Dimensions
          if(parcel.dimensions.width.value == '') {parcelText += `${this.$t('width')}, `; parcelValidation = false};
          if(parcel.dimensions.length.value == '') {parcelText += `${this.$t('length')}, `; parcelValidation = false};
          if(parcel.dimensions.height.value == '') {parcelText += `${this.$t('height')}, `; parcelValidation = false};
          // Dangerous goods
          if (parcel.isDgToggleActive) {
            parcel.dangerousGoodsServices.forEach((row, indexx) => {
              let rowText = `${this.$t('row')} ${(indexx + 1)}: `;
              let rowValidation = true;
              if (row.bruttoWeight.value == '' || row.bruttoWeight.value == 0) {
                rowText += `${this.$t('brutto_weight')}, `;
                rowValidation = false;
                parcelValidation = false;
              }
              if (row.feeWrapperId == '' || row.feeWrapperId == 0) {
                rowText += `${this.$t('type')}, `;
                rowValidation = false;
                parcelValidation = false;
              }
              if (row.dangerousGoodsId == '' || row.dangerousGoodsId == 0) {
                rowText += `${this.$t('un_number')}, `;
                rowValidation = false;
                parcelValidation = false;
              }

              //@todo maybe we need to improve this logic, there is some dynamic field on dg
              // if (row.qty == '' || row.qty == 0) {
              //   rowText += `${this.$t('quantaty')}, `;
              //   rowValidation = false;
              //   parcelValidation = false;
              // }

              if (!rowValidation) {
                // rowText = rowText.replace(/,\s*$/, '');
                parcelText += rowText;
                result = false;
              }
            })
          }
          // Temperature
          if(parcel.isTemperature){
            if(parcel.minTemperature == '') {parcelText += `${this.$t('min_temperature')} ,`; parcelValidation = false};
            if(parcel.maxTemperature == '') {parcelText += `${this.$t('max_temperature')} ,`; parcelValidation = false};
          }

          if(parcel.colliWeight.value == '' || parcel.colliWeight.value == undefined) {
            parcelText += `${this.$t('weight')}, `; parcelValidation = false
          }

          if (this.showColliContent[index]) {
            //Content data is required
            parcel.content.forEach((row, indexx) => {
              let rowText = `${this.$t('row')} ${(indexx + 1)}: `;
              let rowValidation = true;
              /*   if(row.unitWeight.value == '' || row.unitWeight.value == 0){
                   rowText += `${this.$t('weight')}, `; rowValidation = false; parcelValidation = false;
                 };*/
              if(row.qty == '' || row.qty == 0){
                rowText += `${this.$t('quantaty')}, `; rowValidation = false; parcelValidation = false;
              };
              if(!rowValidation){
                // rowText = rowText.replace(/,\s*$/, '');
                parcelText += rowText;
                result = false;
              }
            })
          }
          /*       else {
                   // COlli weight is required
                   if(parcel.colliWeight.value == '' || parcel.colliWeight.value == undefined) {
                     parcelText += `${this.$t('weight')}, `; parcelValidation = false
                   }
                 }*/

          if(!parcelValidation){
            parcelText = parcelText.replace(/,\s*$/, '');
            this.isServicesActiveMessage += parcelText;
            result = false;
          }
        } else if(parseInt(parcel.goodsType) === 2) {
          let parcelValidation = true;
          let parcelText = `</br>&#x2022; ${this.$t('document')} ${index + 1}: `;
          if(parcel.colli == '0') {parcelText += `${this.$t('colli_zero_error')}, `; parcelValidation = false};
          if(parcel.colli == '') {parcelText += `${this.$t('colli_empty_error')}, `; parcelValidation = false};
          // Dimensions
          if(parcel.dimensions.width.value == '') {parcelText += `${this.$t('width')}, `; parcelValidation = false};
          if(parcel.dimensions.length.value == '') {parcelText += `${this.$t('length')}, `; parcelValidation = false};
          if(parcel.dimensions.height.value == '') {parcelText += `${this.$t('height')}, `; parcelValidation = false};
          // COlli weight
          if(parcel.colliWeight.value == '' || parcel.colliWeight.value == undefined) {parcelText += `${this.$t('weight')}, `; parcelValidation = false};

          if(!parcelValidation){
            parcelText = parcelText.replace(/,\s*$/, '');
            this.isServicesActiveMessage += parcelText;
            result = false;
          }
        } else if(parseInt(parcel.goodsType) === 3) {
          let parcelValidation = true;
          let parcelText = `</br>&#x2022; ${this.$t('colli')} ${index + 1}: `;
          if(parcel.colli == '0') {parcelText += `${this.$t('colli_zero_error')}, `; parcelValidation = false};
          if(parcel.colli == '') {parcelText += `${this.$t('colli_empty_error')}, `; parcelValidation = false};
          // Dimensions
          if(parcel.dimensions.width.value == '') {parcelText += `${this.$t('width')}, `; parcelValidation = false};
          if(parcel.dimensions.length.value == '') {parcelText += `${this.$t('length')}, `; parcelValidation = false};
          if(parcel.dimensions.height.value == '') {parcelText += `${this.$t('height')}, `; parcelValidation = false};
          // Temperature
          if(parcel.isTemperature){
            if(parcel.minTemperature == '') {parcelText += `${this.$t('min_temperature')} ,`; parcelValidation = false};
            if(parcel.maxTemperature == '') {parcelText += `${this.$t('max_temperature')} ,`; parcelValidation = false};
          }

          if(parcel.colliWeight.value == '' || parcel.colliWeight.value == undefined) {
            parcelText += `${this.$t('weight')}, `; parcelValidation = false
          }

          if (this.showColliContent[index]) {
            //Content data is required
            parcel.content.forEach((row, indexx) => {
              let rowText = `${this.$t('row')} ${(indexx + 1)}: `;
              let rowValidation = true;
              /*  if(row.unitWeight.value == '' || row.unitWeight.value == 0){
                  rowText += `${this.$t('weight')}, `; rowValidation = false; parcelValidation = false;
                };*/
              if(row.qty == '' || row.qty == 0){
                rowText += `${this.$t('quantaty')}, `; rowValidation = false; parcelValidation = false;
              };
              if(!rowValidation){
                // rowText = rowText.replace(/,\s*$/, '');
                parcelText += rowText;
                result = false;
              }
            })
          }
          /*  else {
              // COlli weight is required
              if(parcel.colliWeight.value == '' || parcel.colliWeight.value == undefined) {
                parcelText += `${this.$t('weight')}, `; parcelValidation = false
              }
            }*/

          //Dangerous goods
          if(parcel.isDgToggleActive){
            parcel.dangerousGoodsServices.forEach((row, indexx) => {
              let rowText = `${this.$t('row')} ${(indexx + 1)}: `;
              let rowValidation = true;
              if (row.bruttoWeight.value == '' || row.bruttoWeight.value == 0) {
                rowText += `${this.$t('brutto_weight')}, `;
                rowValidation = false;
                parcelValidation = false;
              }
              if (row.feeWrapperId == '' || row.feeWrapperId == 0) {
                rowText += `${this.$t('type')}, `;
                rowValidation = false;
                parcelValidation = false;
              }
              if (row.dangerousGoodsId == '' || row.dangerousGoodsId == 0) {
                rowText += `${this.$t('un_number')}, `;
                rowValidation = false;
                parcelValidation = false;
              }

              if(!rowValidation){
                // rowText = rowText.replace(/,\s*$/, '');
                parcelText += rowText;
                result = false;
              }
            })
          }

          if(!parcelValidation){
            parcelText = parcelText.replace(/,\s*$/, '');
            this.isServicesActiveMessage += parcelText;
            result = false;
          }
        } else if(parseInt(parcel.goodsType) === 4) {
          let parcelValidation = true;
          let parcelText = `</br>&#x2022; Load: `;
          // Dimensions
          if(parcel.dimensions.width.value == '' &&
            parcel.dimensions.length.value == '' &&
            parcel.dimensions.height.value == '' &&
            parcel.cubicMeter == '' &&
            parcel.loadMeter == '') {
            parcelText += 'Enter some of dimensions value, ';
            parcelValidation = false;
          }
          // Temperature
          if(parcel.isTemperature){
            if(parcel.minTemperature == '') {parcelText += `${this.$t('min_temperature')} ,`; parcelValidation = false};
            if(parcel.maxTemperature == '') {parcelText += `${this.$t('max_temperature')} ,`; parcelValidation = false};
          }

          if(parcel.colliWeight.value == '' || parcel.colliWeight.value == undefined) {
            parcelText += `${this.$t('weight')}, `; parcelValidation = false
          }

          if (this.showColliContent[index]) {
            //Content data is required
            parcel.content.forEach((row, indexx) => {
              let rowText = `${this.$t('row')} ${(indexx + 1)}: `;
              let rowValidation = true;
              /* if(row.unitWeight.value == '' || row.unitWeight.value == 0){
                 rowText += `${this.$t('weight')}, `; rowValidation = false; parcelValidation = false;
               };*/
              if(row.qty == '' || row.qty == 0){
                rowText += `${this.$t('quantaty')}, `; rowValidation = false; parcelValidation = false;
              };
              if(!rowValidation){
                // rowText = rowText.replace(/,\s*$/, '');
                parcelText += rowText;
                result = false;
              }
            })
          } else {
            // COlli weight is required
            /*  if(parcel.colliWeight.value == '' || parcel.colliWeight.value == undefined) {
                parcelText += `${this.$t('weight')}, `; parcelValidation = false
              }*/
          }

          //Dangerous goods
          if(parcel.isDgToggleActive){
            parcel.dangerousGoodsServices.forEach((row, indexx) => {
              let rowText = `${this.$t('row')} ${(indexx + 1)}: `;
              let rowValidation = true;
              if (row.bruttoWeight.value == '' || row.bruttoWeight.value == 0) {
                rowText += `${this.$t('brutto_weight')}, `;
                rowValidation = false;
                parcelValidation = false;
              }
              if (row.feeWrapperId == '' || row.feeWrapperId == 0) {
                rowText += `${this.$t('type')}, `;
                rowValidation = false;
                parcelValidation = false;
              }
              if (row.dangerousGoodsId == '' || row.dangerousGoodsId == 0) {
                rowText += `${this.$t('un_number')}, `;
                rowValidation = false;
                parcelValidation = false;
              }

              //@todo maybe we need to improve this logic, there is some dynamic field on dg
              // if (row.qty == '' || row.qty == 0) {
              //   rowText += `${this.$t('quantaty')}, `;
              //   rowValidation = false;
              //   parcelValidation = false;
              // }

              if(!rowValidation){
                // rowText = rowText.replace(/,\s*$/, '');
                parcelText += rowText;
                result = false;
              }
            })
          }

          if(!parcelValidation){
            parcelText = parcelText.replace(/,\s*$/, '');
            this.isServicesActiveMessage += parcelText;
            result = false;
          }
        }

      })

      // ICOTERMS VALIDATION
      // if(this.customsData.goods_incoterm == 'DDP' && parseInt(this.customsData.duty_paid_by) === 2 && this.customsData.duty_payer_account_no == ''){
      //   this.isServicesActiveMessage += `</br>&#x2022; ${this.$t('payer_account_number')}`;
      //   result = false;
      // }
      if(parseInt(this.customsData.duty_paid_by) === 3){
        // if(this.customsData.duty_payer_account_no == ''){
        //   this.isServicesActiveMessage += `</br>&#x2022; ${this.$t('payer_account_number')}`;
        //   result = false;
        // }
        // if(this.customsData.customsAddress.address_1 == '') {this.isServicesActiveMessage += `</br>&#x2022; ${this.$t('customs_address')}`; result = false};
        // if(this.customsData.customsAddress.country_id == '') {this.isServicesActiveMessage += `</br>&#x2022; ${this.$t('customs_country_id')}`; result = false};
        // if(this.customsData.customsAddress.post_code == '') {this.isServicesActiveMessage += `</br>&#x2022; ${this.$t('customs_post_code')}`; result = false};
        // if(this.customsData.customsAddress.city == '') {this.isServicesActiveMessage += `</br>&#x2022; ${this.$t('customs_city')}`; result = false};
      }
      // if(parseInt(this.customsData.freight_paid_by) === 2 && this.customsData.freight_payer_account_no == ''){
      //   this.isServicesActiveMessage += `</br>&#x2022; ${this.$t('freight_account_number')}`;
      //   result = false;
      // }

      // END
      this.isServicesActiveMessage = this.isServicesActiveMessage.replace(/,\s*$/, '');
      return result;
    },
    colSize() {
      if(this.custom_tag_json.length == 1){
        return 'col-xs-12';
      } else if(this.custom_tag_json.length == 2){
        return 'col-xs-6';
      } else if(this.custom_tag_json.length == 3){
        return 'col-xs-4';
      } else {
        return 'col-xs-3';
      }
    },
    observableObject() {
      let subaccountId = this.get_active_subaccount.id;
      if (this.getShowInfoBox() && this.bookingSubaccount) {
        subaccountId = this.bookingSubaccount;
      }

      return {
        senderHandlingType: this.senderHandlingType,
        subaccountId: subaccountId,
        shippingDate: this.shippingDate,
        //fromAddress: this.fromAddress.address_1,
        fromCountry: this.fromAddress.country_id,
        fromPostcode: this.fromAddress.post_code,
        //fromCity: this.fromAddress.city,
        //pickupAddress: this.waybillAddress.address_1,
        pickupCountry: this.waybillAddress.country_id,
        pickupPostcode: this.waybillAddress.post_code,
        //pickupCity: this.waybillAddress.city,
        //toAddress: this.toAddress.address_1,
        toCountry: this.toAddress.country_id,
        toPostcode: this.toAddress.post_code,
        //toCity: this.toAddress.city,
        activeGoodsTypes: this.activeGoodsTypes,
        colli: this.parseColliObservable(),
        goodsIncoterms: this.customsData.goods_incoterm,
        showCustoms: this.showCustoms,
        //senderReference: this.fromData.reference,
        //reciverReference: this.toData.reference,
      };
    },
    dataForProducts() {
      return {
        senderHandlingType: this.senderHandlingType,
        subaccountId: this.bookingSubaccount ? this.bookingSubaccount : this.get_active_subaccount.id,
        shippingDate: this.shippingDate,
        fromAddress: this.fromAddress,
        fromData: this.fromData,
        pickupAddress: this.waybillAddress,
        pickupData: this.waybillData,
        useDiffPickupAddress: this.toWaybill,
        toAddress: this.toAddress,
        toData: this.toData,
        activeGoodsTypes: this.activeGoodsTypes,
        colli: this.parseColli(),
        useContentOnShipmentLevel: this.useContentOnShipmentLevel,
        customsData: this.customsData,
        showCustoms: this.showCustoms,
        isSenderReferenceRequired: this.isSenderReferenceRequired,
        isReceiverReferenceRequired: this.isReceiverReferenceRequired,
        isPhoneRequired: this.isPhoneRequired,
        isEmailRequired: this.isEmailRequired,
        broker_details: this.customsData.clearance_by === 'broker' ? (this.get_brokers.items || this.get_brokers || []).find(opt => opt.id === this.customsData.broker_id) : null,
      };
    },
  },
  beforeRouteLeave(to, from, next) {
    if (!this.bookingCompleted && this.hasChanges && !this.showSaveDialog && this.bookingType === 'standard') {
      // Store the pending navigation
      this.pendingNavigation = next
      // Show the save dialog
      this.showSaveDialog = true
      // Prevent immediate navigation
      next(false)
      return
    }
    // If no changes or dialog already shown, proceed
    next()
  },
  methods: {
    handleReceiverAdditionalInfo(data) {
      // Update customs data if available
      if (data.goods_incoterm) {
        this.customsData.goods_incoterm = data.goods_incoterm;
      }

      if (data.duty_paid_by) {
        this.customsData.duty_paid_by = data.duty_paid_by;
      }

      if (data.duty_payer_account_no) {
        this.customsData.duty_payer_account_no = data.duty_payer_account_no;
      }

      if (data.freight_paid_by) {
        this.customsData.freight_paid_by = data.freight_paid_by;
      }

      if (data.freight_payer_account_no) {
        this.customsData.freight_payer_account_no = data.freight_payer_account_no;
      }

      if (data.freight_payer_id) {
        this.customsData.freight_payer_id = data.freight_payer_id;
      }

      // Update additional info fields
      if (data.invoice_type) {
        this.invoiceType = data.invoice_type;
      }

      if (data.eori) {
        this.eori = data.eori;
      }

      if (data.eccn) {
        this.eccn = data.eccn;
      }

      if (data.customs_additional_info_text) {
        this.customsAdditionalInfoText = data.customs_additional_info_text;
      }

      if (data.eei_number || data.tin_number || data.tin_type) {
        this.eeiitn = {
          eei: data.eei_number || '',
          tinNumber: data.tin_number || '',
          tinType: data.tin_type || ''
        };
      }

      // Update selected info items if available
      if (data.selected_info_items && Array.isArray(data.selected_info_items) && data.selected_info_items.length > 0) {
        this.selectedInfoItems = [...data.selected_info_items];
      }

      // Log for debugging (remove in production)
      // console.log('Receiver additional shipping info applied:', {
      //   customs: this.customsData,
      //   invoiceType: this.invoiceType,
      //   eori: this.eori,
      //   eccn: this.eccn,
      //   eeiitn: this.eeiitn,
      //   selectedInfoItems: this.selectedInfoItems
      // });
    },
    handleAdditionalInfoSelected(data) {
      console.log('Additional shipping info selected:', data);

      const { customer_id, additionalInfo } = data;

      // Update customs data
      if (additionalInfo.goods_incoterm) {
        this.customsData.goods_incoterm = additionalInfo.goods_incoterm;
      }

      if (additionalInfo.duty_paid_by) {
        this.customsData.duty_paid_by = additionalInfo.duty_paid_by;
      }

      if (additionalInfo.duty_payer_account_no) {
        this.customsData.duty_payer_account_no = additionalInfo.duty_payer_account_no;
      }

      if (additionalInfo.freight_paid_by) {
        this.customsData.freight_paid_by = additionalInfo.freight_paid_by;
      }

      if (additionalInfo.freight_payer_account_no) {
        this.customsData.freight_payer_account_no = additionalInfo.freight_payer_account_no;
      }

      if (additionalInfo.freight_payer_id) {
        this.customsData.freight_payer_id = additionalInfo.freight_payer_id;
      }

      // Update additional info fields
      if (additionalInfo.invoice_type) {
        this.invoiceType = additionalInfo.invoice_type;
      }

      if (additionalInfo.eori) {
        this.eori = additionalInfo.eori;
      }

      if (additionalInfo.eccn) {
        this.eccn = additionalInfo.eccn;
      }

      if (additionalInfo.mrn) {
        this.mrn = additionalInfo.mrn;
      }

      if (additionalInfo.customs_additional_info_text) {
        this.customsAdditionalInfoText = additionalInfo.customs_additional_info_text;
      }

      if (additionalInfo.eei_number || additionalInfo.tin_number || additionalInfo.tin_type) {
        this.eeiitn = {
          eei: additionalInfo.eei_number || '',
          tinNumber: additionalInfo.tin_number || '',
          tinType: additionalInfo.tin_type || ''
        };
      }

      // Update selected info items
      if (additionalInfo.selected_info_items_array && additionalInfo.selected_info_items_array.length > 0) {
        this.selectedInfoItems = [...additionalInfo.selected_info_items_array];
      }
    },
    onSenderHandlingTypeChange(val) {
      this.senderHandlingType = parseInt(val) || 1;
      this.toWaybill = (parseInt(val) === 2); //is pickup at other address than shipper
    },
    onReceiverHandlingTypeChange(val) {
      this.receiverHandlingType = val;
    },
    initializeTrackedState() {
      const initialStateData = initialState();
      this.originalTrackedState = this.trackedKeys.reduce((acc, key) => {
        acc[key] = _.cloneDeep(initialStateData[key]);
        return acc;
      }, {});
    },
    toggleUseContentOnShipmentLevel() {
      this.useContentOnShipmentLevel = !this.useContentOnShipmentLevel;
      this.setShowColliContent()
    },
    updateAdditionalInfo(data) {
      const { eori, eccn, customsAdditionalInfoText, invoiceType, eeiitn , mrn} = data;

      this.eori = eori;
      this.eccn = eccn;
      this.customsAdditionalInfoText = customsAdditionalInfoText;
      this.mrn = mrn;
      this.invoiceType = invoiceType;
      this.$set(this, 'eeiitn', { ...eeiitn });
    },
    updateSelectedInfo(value) {
      this.selectedInfoItems = value
    },
    setShippingDate(date) {
      this.shippingDate = date
    },
    togglePrivateAddress()
    {
      this.toData.shipToPrivateResident = !this.toData.shipToPrivateResident
    },
    toggleFromPrivateAddress() {
      this.fromData.shipFromPrivateResident = !this.fromData.shipFromPrivateResident
    },
    onChangeShipperType(val) {
      this.shipperType = val;
      this.fromData.shipFromPrivateResident = (val === 'private');
      //Sometimes on copy, watcher just dont wanna register shipFromPrivateResident change, dont know why
      if (val === 'private') {
        this.fromData.company = '';
      }
    },
    onChangeReceiverType(val) {
      this.receiverType = val;
      this.toData.shipToPrivateResident = (val === 'private');
      if (val === 'private') {
        this.toData.company = '';
      }
    },
    postCodeRequired(type) {
      if( this[`${type}Address`] && this[`${type}Address`].country_id !== '' && this[`${type}Address`].country_id !== undefined){
        return !!Number(countryList.filter((opt) => opt.id === this[`${type}Address`].country_id.toString())[0].has_postcode)
      }
      return true;
    },
    setBookingSubaccount(subaccountId) {
      this.bookingSubaccount = subaccountId
      this.subaccountId = subaccountId;
    },
    mergeShipmentPackages(oldObject, newObject) {
      const dimensions = {
        width: {
          disabled: false,
          value: oldObject.dimensions.width.value
        },
        height: {
          disabled: false,
          value: oldObject.dimensions.height.value
        },
        length: {
          disabled: false,
          value: oldObject.dimensions.length.value
        }
      }
      const mergeData = {
        colli: oldObject.colli ? oldObject.colli : 1,
        dimensions: dimensions,
        colliWeight: oldObject.colliWeight,
        content: oldObject.content,
        dangerousGoodsServices: oldObject.dangerousGoodsServices,
        isDgToggleActive: oldObject.isDgToggleActive ? oldObject.isDgToggleActive : false,
        packingType: oldObject.packingType,
        packingTypeOption: oldObject.packingTypeOption,
        allPackedInOne: oldObject.allPackedInOne,
        iataRadioactive: oldObject.iataRadioactive,
        iataLimitations: oldObject.iataLimitations,
        iataAdditionalInfo: oldObject.iataAdditionalInfo,
        qty: oldObject.qty,
        Q: oldObject.Q,
        description: oldObject.description
      }

      return {
        ...newObject,
        ...mergeData
      }
    },
    dgTypeChanged(val) {
      this.dgType = val.dgType;
      this.dgTypeShownOnPackageCustomId = val.packageId;
      //Used to change dg type on all existing packages
      this.shipmentPackages.forEach((pack, packageIndex) => {
        pack.dangerousGoodsServices.forEach((service, serviceIndex) => {
          this.$set(this.shipmentPackages[packageIndex].dangerousGoodsServices[serviceIndex], 'feeWrapperId', this.dgType);
          this.$set(this.shipmentPackages[packageIndex], 'iataLimitations', val.iataLimitations);
          this.$set(this.shipmentPackages[packageIndex], 'iataRadioactive', val.iataRadioactive);
          this.$set(this.shipmentPackages[packageIndex], 'iataAdditionalInfo', val.iataAdditionalInfo);
        });
      });
    },
    packagingTypeChange(index){
      let shipmentPackage = this.shipmentPackages[index]
      shipmentPackage.dangerousGoodsServices.forEach((service, serviceIndex) => {
        this.$set(this.shipmentPackages[index].dangerousGoodsServices[serviceIndex], 'iataLimitations', null);
        this.$set(this.shipmentPackages[index].dangerousGoodsServices[serviceIndex], 'iataRadiation', null);
        this.$set(this.shipmentPackages[index].dangerousGoodsServices[serviceIndex], 'iataAdditionalInfo', null);
      })
    },
    packagingTypeOptionChange(index){
      let shipmentPackage = this.shipmentPackages[index]
      shipmentPackage.dangerousGoodsServices.forEach((service, serviceIndex) => {
        this.$set(this.shipmentPackages[index].dangerousGoodsServices[serviceIndex], 'innerPackaging', null);
        this.$set(this.shipmentPackages[index].dangerousGoodsServices[serviceIndex], 'innerPackagingQty', null);
      })
    },
    resetShippment() {
      if ('Production' === process.env.VUE_APP_MODE) {
        this.$router.go();
      }
      //Object.assign(this.$data, initialState())
    },
    transformPalletExchange (palletExchanges) {
      if (!palletExchanges) return null;

      return palletExchanges.map(obj => {
        return {
          ...obj
        }
      })
    },
    transformColliContent (shipmentPackagesIndex, contents, isObservable = false) {
      //Content should be set only if is seen
      if (!this.useContentOnShipmentLevel && !this.showColliContent[shipmentPackagesIndex]) {
        return [];
      }

      if (this.useContentOnShipmentLevel && !this.showCustoms && !this.systemShowColliContent) {
        return [];
      }

      return contents.map(content => {
        if (isObservable) {
          return {
            quantity: content.qty,
            unit_weight: content.unitWeight.value,
            unit_weight_unit: content.unitWeight.unit,
          };
        } else {
          return {
            quantity: content.qty,
            description: content.description,
            unit_weight: content.unitWeight.value,
            unit_weight_unit: content.unitWeight.unit,
            unit_value: content.unitValue.value,
            unit_value_currency: content.unitValue.unit,
            hs_code: content.hsCode,
            origin_country_id: content.origin,
          };
        }
      });
    },
    transformColliService (colli, isObservable = false) {
      //If DG toggle is off or user has disabled dangerous goods, do not use DG services
      if (!colli.isDgToggleActive || !this.show_dangerous_goods) {
        return [];
      }

      return colli.dangerousGoodsServices.map(service => {
        //If allPackedInOne option is set to no, then use notAllInOneQty otherwise use colli qty (2 = Not all packed in one)
        let qty = parseInt(colli.allPackedInOne) === 2 ? service.notAllInOneQty : colli.qty;
        //For parcel and load we will not show qty, colli number will be used, only for pallet qty will remain (document goods type does not have dg)
        qty = [1, 4].includes(parseInt(colli.goodsType)) ? colli.colli : qty;
        let packingType = parseInt(colli.allPackedInOne) === 2 ? service.notAllInOneOuterPackaging : colli.packingType;

        if (isObservable) {
          return {
            qty: qty,
            Q: colli.Q,
            fee_wrapper_id: service.feeWrapperId,
            dangerous_goods_id: service.dangerousGoodsId,
            packing_type: colli.packingType,
            packing_type_option: colli.packingTypeOption,
            all_packed_in_one: colli.allPackedInOne,
            iata_limitations: colli.iataLimitations,
            iata_radioactive: colli.iataRadioactive,
            iata_additional_info: colli.iataAdditionalInfo,
            nem_weight: service.nemWeight.value,
            nem_weight_unit: service.nemWeight.unit,
            net_weight: service.netWeight.value,
            net_weight_unit: service.netWeight.unit,
            brutto_weight: service.bruttoWeight.value,
            brutto_weight_unit: service.bruttoWeight.unit,
            is_limited_quantity: service.isLimitedQuantity,
            is_excepted_quantity: service.isExceptedQuantity,
            inner_packaging: service.innerPackagingQty && parseInt(service.innerPackagingQty) > 0 ? service.innerPackaging : '',
          }
        } else {
          return {
            qty: qty,
            Q: colli.Q,
            fee_wrapper_id: service.feeWrapperId,
            dangerous_goods_id: service.dangerousGoodsId,
            packing_type: packingType,
            packing_type_option: colli.packingTypeOption,
            is_overpack: colli.isOverpack,
            all_packed_in_one: colli.allPackedInOne,
            iata_limitations: colli.iataLimitations,
            iata_radioactive: colli.iataRadioactive,
            iata_additional_info: colli.iataAdditionalInfo,
            nem_weight: service.nemWeight.value,
            nem_weight_unit: service.nemWeight.unit,
            net_weight: service.netWeight.value,
            net_weight_unit: service.netWeight.unit,
            brutto_weight: service.bruttoWeight.value,
            brutto_weight_unit: service.bruttoWeight.unit,
            is_environmental_hazard: service.isEnvironmentalHazard,
            is_marine_pollutant: service.isMarinePollutant,
            english_technical_designation: service.englishTechnicalDesignation,
            danish_technical_designation: service.danishTechnicalDesignation,
            iata_autorization: service.iataAutorization,
            flash_point: service.flashPoint,
            segregation_group: service.segregationGroup,
            ems: service.ems,
            inner_packaging: service.innerPackagingQty && parseInt(service.innerPackagingQty) > 0 ? service.innerPackaging : '',
            //inner_packaging: service.innerPackaging,
            inner_packaging_qty: service.innerPackagingQty,
            packing_instruction: service.packingInstruction,
            is_limited_quantity: service.isLimitedQuantity,
            is_excepted_quantity: service.isExceptedQuantity
          }
        }
      });
    },
    setShowColliContent() {
      this.shipmentPackages.forEach((pack,index) => {
        if (this.useContentOnShipmentLevel) {
          this.showColliContent[index] = false;
        } else {
          if (parseInt(pack.goodsType) === 2) {//For document goods type, content is never shown
            this.showColliContent[index] = false;
          } else if (this.showCustoms) {//If shipment is customs declarable we need to show content
            this.showColliContent[index] = true
          } else {
            this.showColliContent[index] = this.systemShowColliContent;
          }
        }
      })
    },
    getShowInfoBox() {
      //If shipment is show_booking_info_box true and there is more than 1 active accounts
      if (this.showInfoBox === true && this.get_user.accessible_subaccounts_array.length > 1) {
        return this.showInfoBox;
      }
      this.isInitialized = true;
    },
    closeUnapprovedPopup() {
      this.showUnapprovedPopup = false;
      this.resetShippment()
    },
    handleCancel() {
      this.showSaveDialog = false
      // Clear the pending navigation
      this.pendingNavigation = null
    },
    handleDontSave() {
      this.showSaveDialog = false
      // Continue with the stored navigation
      if (this.pendingNavigation) {
        this.pendingNavigation()
      }
    },
    saveDraft() {
      this.$store.dispatch('SAVE_DRAFT', this.prepareBookShipmentObject({
        droppoint_no: null,
        product: null, //this.selectedProduct was used, cannot be used here cause its not up to date, it is updated on select product event and some actions are done after that event
        notification: null,
        services: [],
        additionalFieldData: null,
        pickup_driver_note: null,
        pickup_time_from: null,
        pickup_time_until: null,
        pickup_time_zone: null,
        pickup_action: null,
        pickup_product_id: null,
        pickup_ship_date: null
      })).finally(() => {
        this.showSaveDialog = false
        // Continue with the stored navigation
        if (this.pendingNavigation) {
          this.pendingNavigation()
        }
      })
    },
    // BOOKING SHIPMENT
    bookShipment(productsServicesNotification) {
      let cancelBooking = false;
      this.bookingCompleted = false
      let tagError = '';
      this.draftError = null;
      this.custom_tag_json.forEach((tag, index) => {
        const value = tag?.custom_tag_value;
        const hasValue = value !== null && value !== undefined && String(value).trim() !== '';
        if (tag.custom_tag_is_required && !hasValue) {
          tagError += `${tag.custom_tag_name} ${this.$t('tag required')}</br>`;
          cancelBooking = true;
        }
      })
      if(cancelBooking) {
        this.$store.commit('SHOW_NOTIFICATION_BAR', {
          message: tagError,
          type: 'alert-window'
        });
        return;
      };
      if (!this.toData.shipToPrivateResident && !this.toData.company) {
        this.$store.commit('SHOW_NOTIFICATION_BAR', {
          message: 'receiver_company_name_is_required',
          type: 'alert-window'
        });
        return;
      }
      if (!this.toAddress.address_1 || !this.fromAddress.address_1) {
        this.$store.commit('SHOW_NOTIFICATION_BAR', {
          message: 'address_1_is_required',
          type: 'alert-window'
        });
        return;
      }
      if (!this.toAddress.city || !this.fromAddress.city) {
        this.$store.commit('SHOW_NOTIFICATION_BAR', {
          message: 'city_is_required',
          type: 'alert-window'
        });
        return;
      }
      //Book pickup option is visible but pickup product ID is not valid
      if (productsServicesNotification.pickup_product_id === 0) {
        this.$store.commit('SHOW_NOTIFICATION_BAR', {
          message: 'pickup_product_is_required',
          type: 'alert-window'
        });
        return;
      }
      //Trigger generate waybill popup
      if(this.shipmentPopup){
        if(this.needApproval) {
          this.showUnapprovedPopup = true;
        } else {
          this.isPDFGenerated = false;
          this.showShipmentPopup = true;
        }
      }

      this.$store.dispatch('BOOK_SHIPMENT', this.prepareBookShipmentObject(productsServicesNotification)).then((res) => {
        if (!res) return;
        if(res.hasOwnProperty('error')){
          this.$store.commit('SHOW_NOTIFICATION_BAR', {
            message: res.error,
            type: 'alert-window',
            iconName: 'check',
          });
          //this.draftError = res.error;
          this.showShipmentPopup = false;
          this.showUnapprovedPopup = false;
          return;
        }
        this.bookingCompleted = true
        this.shippingAgentName = res.shipping_agent_name;
        this.shipmentId = res.id;
        this.dgFilePath = res.dg_file || '';
        this.batchNumber = res.batch_number || null;
        this.downloadEodName = `EOD_${res.batch_number || ''}`;
        this.numPages = 1;
        if(this.draftShippmentId != '' && this.get_editing_shipment.shipmentType == 'draft') {
          this.$store.dispatch('DELETE_DRAFTS', {
            type: 'byId',
            id: 0,
            ids: [this.draftShippmentId],
          });
        }
        if(this.draftShippmentId != '' && this.get_editing_shipment.shipmentType == 'unapproved') {
          this.$store.dispatch('DELETE_UNAPPROVEDS', {
            type: 'byId',
            id: 0,
            ids: [this.draftShippmentId],
          });
        }
        // IF NEEDS APPROVAL
        if(this.shipmentPopup) {
          if(!this.needApproval) {
            this.shipmentTraceNo = res.trace_no;
            this.pdfName = `Waybill-${res.trace_no}-${res.shipping_agent_name}-${res.shipping_product_name}-${res.created_at}.pdf`;
            this.$store.dispatch('GET_LABEL', res.id).then((res) => {
              this.$nextTick(() => {
                const urlCreator = window.URL || window.webkitURL;
                let file = urlCreator.createObjectURL(res);
                this.$refs.printPDF.src = file;
                this.$refs.downloadPDF.href = file;
                this.isPDFGenerated = true;
                this.pdfFilePath = file;
              })
            })
          }
        } else {
          this.redirectFromShipment();
        }
      });
    },
    prepareBookShipmentObject(productsServicesNotification) {
      let customs_additional_info_json = {};
      if(this.eori != ''){
        customs_additional_info_json.eori = this.eori;
      }
      if(this.eccn != ''){
        customs_additional_info_json.eccn = this.eccn;
      }
      if(this.customsAdditionalInfoText != ''){
        customs_additional_info_json.text = this.customsAdditionalInfoText;
      }
      if(this.mrn != ''){
        customs_additional_info_json.mrn = this.mrn;
      }
      if (this.eeiitn.eei != '' || this.eeiitn.tinType  != '' || this.eeiitn.tinNumber) {
        customs_additional_info_json.eeiitn = {
          eei: this.eeiitn.eei,
          tinType: this.eeiitn.tinType,
          tinNumber: this.eeiitn.tinNumber,
        };
      } else {
        customs_additional_info_json.eeiitn = null;
      }

      let subaccountId = this.get_active_subaccount.id;
      if (this.getShowInfoBox() && this.bookingSubaccount) {
        subaccountId = this.bookingSubaccount;
      }

      return {
        // GLOBALS
        ship_date: productsServicesNotification.pickup_ship_date ? productsServicesNotification.pickup_ship_date : this.shippingDate,
        subaccount_id: subaccountId,
        // SENDER
        sender: {
          company_name: this.fromData.company,
          name: this.fromData.attention,
          address_1: this.fromAddress.address_1,
          address_2: this.fromAddress.address_2,
          city: this.fromAddress.city,
          post_code: this.fromAddress.post_code,
          country_id: this.fromAddress.country_id,
          phone: this.fromData.phone.number,
          email: this.fromData.email,
          state:  this.fromAddress.state,
          vat: this.fromData.vat ? this.fromData.vat : null,
        },
        save_sender_location: this.saveShipperLocation,
        //Will be used for pickup address
        sender_waybill: {
          company_name: this.waybillData.company,
          name: this.waybillData.attention,
          address_1: this.waybillAddress.address_1,
          address_2: this.waybillAddress.address_2,
          city: this.waybillAddress.city,
          post_code: this.waybillAddress.post_code,
          country_id: this.waybillAddress.country_id,
          phone: this.waybillData.phone.number,
          email: this.waybillData.email,
          state:  this.waybillAddress.state,
        },
        // RECIEVER
        customer: {
          company_name: this.toData.company,
          name: this.toData.attention,
          address_1: this.toAddress.address_1,
          address_2: this.toAddress.address_2,
          city: this.toAddress.city,
          post_code: this.toAddress.post_code,
          country_id: this.toAddress.country_id,
          phone: this.toData.phone.number,
          email: this.toData.email,
          state:  this.toAddress.state,
          vat: this.toData.vat ? this.toData.vat : null,
        },
        // CUSTOMS
        customs: {
          company_name: this.customsAddressData.company,
          name: this.customsAddressData.attention,
          address_1: this.customsAddress.address_1,
          address_2: this.customsAddress.address_2,
          city: this.customsAddress.city,
          post_code: this.customsAddress.post_code,
          country_id: this.customsAddress.country_id,
          phone: this.customsAddressData.phone.number,
          email: this.customsAddressData.email,
          state:  this.customsAddress.state,
          vat: this.customsAddressData.vat ? this.customsAddressData.vat : null,
        },
        sender_handling_type: this.senderHandlingType,
        use_content_on_shipment_level: this.useContentOnShipmentLevel,
        customs_additional_info_json: customs_additional_info_json,
        customs_reference: this.customsAddressData.reference,
        customs_files: this.invoiceFiles,
        customs_file_origin: this.isActiveCustom ? '1' : '2',
        goods_incoterm: this.customsData.goods_incoterm, // dodao od gileta
        should_create_customs_file: this.showCustoms ? '1' : '0',
        should_send_customs_file: productsServicesNotification.product && productsServicesNotification.product.should_send_customs_file,
        invoice_type: this.invoiceType,
        duty_paid_by: this.customsData.duty_paid_by,
        duty_payer_account_no: this.customsData.duty_payer_account_no,
        freight_paid_by: this.customsData.freight_paid_by,
        freight_payer_account_no: this.customsData.freight_payer_account_no,
        freight_payer_id: this.customsData.freight_payer_id,
        clearance_by: this.customsData.clearance_by,
        broker_details: this.customsData.clearance_by === 'broker' ? (this.get_brokers.items || this.get_brokers || []).find(opt => opt.id === this.customsData.broker_id) : null,
        freight_booking_confirmation_no: productsServicesNotification.product ? productsServicesNotification.product.freight_booking_confirmation_no : null,
        //Pickup
        pickup_time_from:  productsServicesNotification.pickup_time_from,
        pickup_time_until:  productsServicesNotification.pickup_time_until,
        pickup_time_zone:  productsServicesNotification.pickup_time_zone,
        pickup_driver_note:  productsServicesNotification.pickup_driver_note,
        pickup_action: productsServicesNotification.pickup_action,
        pickup_ship_date:  productsServicesNotification.product ? productsServicesNotification.product.pickup_ship_date : null,
        pickup_product_id: productsServicesNotification.pickup_product_id ? productsServicesNotification.pickup_product_id : null,
        // GOODS
        goods_description: '', // posalji prazno
        goods_value_currency: '', // posalji prazno
        goods_value: '', // posalji prazno
        goods_type: this.activeGoodsTypes,
        colli: this.dataForProducts.colli,
        // dodaj delivery za pickup point
        sender_id: this.shipper != null ? this.shipper : '0',
        sender_waybill_address_id: this.waybillShipper ? this.waybillShipper : '0',
        shipping_product_id: productsServicesNotification.product ? productsServicesNotification.product.shipping_product_id : null, // CHECK
        sender_reference: this.fromData.reference, // CHECK
        receiver_reference: this.toData.reference, // CHECK
        shipment_type: '1', // ZAKUCANO
        //DROPPOINT
        droppoint_no: productsServicesNotification.droppoint_no,
        is_return: this.isReturn,
        fee_wrapper_ids_json: productsServicesNotification.services.length ? productsServicesNotification.services.filter((value, index, array) => array.indexOf(value) === index) : productsServicesNotification.services, // set unique services
        active_services_json: productsServicesNotification.additionalFieldData,
        insurance_amount: '', // vidi sa Danijelom
        insurance_content: '', // vidi sa Danijelom
        carrier_account: '', // posalji prazno
        custom_tags_json: this.custom_tag_json,
        shipment_notification_event: productsServicesNotification.notification ? productsServicesNotification.notification.shipmentNotificationType : null,
        notification_receiver: productsServicesNotification.notification ? productsServicesNotification.notification.notification_receiver : null,
        other_notification_event: productsServicesNotification.notification ? productsServicesNotification.notification.other_notification_event : null,
        transit_time: productsServicesNotification.product ? productsServicesNotification.product.estimated_time.value : null,
      }
    },
    swapData() {
      const fromData = { ...this.fromData };
      const toData = { ...this.toData };
      const fromAddress = { ...this.fromAddress };
      const toAddress = { ...this.toAddress };
      this.fromData = toData;
      this.toData = fromData;
      this.fromAddress = toAddress;
      this.toAddress = fromAddress;

      this.swapped = !this.swapped;
      if(this.swapped){
        this.cachedShipper = this.shipper;
        this.shipper = null;
        this.foreignShipper = true;
        this.isShipperInFrom = false;
      } else {
        this.shipper = this.cachedShipper;
        this.foreignShipper = false;
        this.isShipperInFrom = true;
      }


      setTimeout(() => {
        this.toData = fromData;
      }, 2000)

      if(!this.toData?.shipToPrivateResident) {
        this.toData.shipToPrivateResident = false
      }

      if(!this.fromData?.shipFromPrivateResident) {
        this.fromData.shipFromPrivateResident = false
      }

      this.toWaybill = false;
      this.clearAddressData('waybill');
    },
    /**
     * Called from address book
     * @param type
     * @param val
     */
    changeAddress(type, val) {
      const address = this[`${type}Address`];
      const data = this[`${type}Data`];
      const addressData = this[`${type}AddressData`];

      address.address_1 = val.address_1 || '';
      address.address_2 = val.address_2 || '';
      address.country_id = val.country_id || '';
      address.post_code = val.post_code || '';
      address.city = val.city || '';

      const countryName = this.getCountry(val.country_id, 'name');
      address.state = stateList.some(state => state.country_name === countryName) ? val.state : '';

      if (val.typeOfAction === 'app') {
        if (type === 'customs') {
          addressData.company = val.company_name || '';
          addressData.attention = val.name || '';
          addressData.email = val.email || '';
          addressData.phone.number = val.phone || '';
          addressData.vat = val.vat || '';
        } else {
          const checkFrom = !this.foreignShipper && type === 'from';
          data.company = val.company_name || '';
          data.attention = val.name || (checkFrom ? `${this.get_user.first_name} ${this.get_user.last_name}` : '');
          data.email = val.email || (checkFrom ? this.get_user.email : '');
          data.phone.number = val.phone && val.phone.length > 4 ? val.phone : (checkFrom ? this.get_user.phone : '');
          data.vat = val.vat || '';
        }
      }

      if (type === 'to' && val.customer_type) {
        const isReceiverPrivate = parseInt(val.customer_type) === 2;
        this.onChangeReceiverType(isReceiverPrivate ? 'private' : 'company');
      }

      if (type === 'from' && val.customer_type) {
        const isShipperPrivate = parseInt(val.customer_type) === 2;
        this.onChangeShipperType(isShipperPrivate ? 'private' : 'company');
      }
    },
    clearAddressData(type) {
      this[`${type}Address`].address_1 = '';
      this[`${type}Address`].address_2 = '';
      this[`${type}Address`].country_id = '';
      this[`${type}Address`].post_code = '';
      this[`${type}Address`].city = '';
      this[`${type}Address`].state = '';

      this[`${type}Data`].company = '';
      if (type == 'to') {
        //this[`${type}Data`].shipToPrivateResident = false;
      }
      if (type == 'from') {
        //this[`${type}Data`].shipFromPrivateResident = false;
      }
      this[`${type}Data`].attention = '';
      this[`${type}Data`].email = '';
      this[`${type}Data`].phone = {
        number: '',
        country: '',
      };

      if (this[`${type}Data`].vat) {
        this[`${type}Data`].vat = '';
      }
    },
    checkForForeignShipper(val) {
      if (val === null) {
        this.foreignShipper = true;
        if(!this.isShipperInFrom){
          this.clearAddressData('from');
        } else {
          this.clearAddressData('from');
          this.cachedShipper = null;
        }
      } else {
        this.foreignShipper = false;
        const shipperData = this.get_shippers.find((opt) => opt.id === val);
        const userData = this.get_user;
        const isPrivate = parseInt(shipperData.contact_type) === 2;
        this.onChangeShipperType(isPrivate ? 'private' : 'company')
        this.fromData = {
          reference: this.fromData.reference,
          company: shipperData.company_name || '',
          attention: shipperData.name ? shipperData.name : (userData.first_name + ' ' + userData.last_name),
          email: shipperData.email ? shipperData.email : userData.email,
          //shipToPrivateResident: false,
          shipFromPrivateResident: isPrivate,
          phone: {
            number: (shipperData.phone.length > 4) ? shipperData.phone : userData.phone,
            country: (shipperData.phone.length > 4) && shipperData.country_id ? countryList.filter((opt) => parseInt(opt.id) === parseInt(shipperData.country_id))[0].alpha2 : ''
          },
          vat: shipperData.vat || '',
        };
        this.fromAddress = {
          address_1: shipperData.address_1,
          address_2: shipperData.address_2,
          city: shipperData.city,
          country_id: shipperData.country_id,
          post_code: shipperData.post_code,
          state: shipperData.state,
        };
      }
    },
    setReceiverData(val) {
      if (val === null) {
        this.clearAddressData('to');
      } else {
        const data = this.get_shippers.find((opt) => opt.id === val);
        const isPrivate = parseInt(data.contact_type) === 2;
        this.onChangeReceiverType(isPrivate ? 'private' : 'company');

        // Set basic receiver data
        this.toData = {
          reference: this.toData.reference, // Keep existing reference
          company: data.company_name || '',
          attention: data.name,
          email: data.email,
          shipToPrivateResident: isPrivate,
          phone: {
            'number': data.phone,
            'country': countryList.filter((opt) => parseInt(opt.id) === parseInt(data.country_id))[0].alpha2
          },
          vat: data.vat || ''
        };

        // Set basic address data
        this.toAddress = {
          address_1: data.address_1,
          address_2: data.address_2,
          city: data.city,
          country_id: data.country_id,
          post_code: data.post_code,
          state: data.state,
        };

        // Handle additional shipping information (similar to handleAdditionalInfoSelected)
        this.handleReceiverAdditionalInfo(data);
      }
    },
    changeWaybillAddressShipper(val) {
      //val is empty if user choose 'other address' option
      if (!val) {
        this.clearAddressData('waybill');
      } else {
        const data = this.get_shippers.find((opt) => opt.id === val);
        this.waybillAddress = {
          address_1: data.address_1,
          address_2: data.address_2,
          city: data.city,
          country_id: data.country_id,
          post_code: data.post_code,
          state: data.state,
        };
        this.waybillData = {
          company: data.company_name || '',
          attention: data.name || '',
          email: data.email || '',
          phone: {
            number: data.phone || '',
            country: data.country_id ? countryList.filter((opt) => parseInt(opt.id) === parseInt(data.country_id))[0].alpha2 : ''
          },
        };
      }
    },
    clearFromFields() {
      this.waybillShipper = null;
      this.foreignShipper = false;
      this.shipper = this.get_user.sender_id;
      this.cachedShipper = this.shipper;
      this.clearAddressData('waybill');
      this.clearAddressData('from');
    },
    isMemberOfEU(id) {
      return !!Number(this.getCountry(id, 'member_of_the_eu', '3'));
    },
    showCombinedState(){
      this.showOrigin = true;
      if(this.toAddress.country_id != '' && this.fromAddress.country_id != ''){
        if(  this.isMemberOfEU(this.fromAddress.country_id) && this.isMemberOfEU(this.toAddress.country_id) ){
          this.showOrigin = false;
        } else if( !this.isMemberOfEU(this.fromAddress.country_id) && this.isMemberOfEU(this.toAddress.country_id) ) {
          this.showOrigin = true;
        } else if( !this.isMemberOfEU(this.fromAddress.country_id) && !this.isMemberOfEU(this.toAddress.country_id) ) {
          this.showOrigin = true;
        } else {
          this.showOrigin = true;
        }
      } else {
        if(this.fromAddress.country_id == '') return;
        if(this.isMemberOfEU(this.fromAddress.country_id)){
          this.showOrigin = false;
        }
      }
    },
    // CUSTOMS INFORMATION
    customInfo() {
      this.invoiceFiles = null;
      this.invoiceFileName = '';
      this.isActiveCustom = true;
    },
    addFiles(files) {
      this.invoiceFiles = files;
      this.customsData.invoiceFiles = files;
    },
    updateDocumentType(type) {
      this.$set(this.customsData, 'documentType', type);
    },
    isInfoValid(type) {
      if(this.postCodeRequired(type) && this[`${type}Address`].post_code == undefined || this[`${type}Address`].post_code == null) return false;
      if(this[`${type}Address`].country_id == '' || this[`${type}Address`].country_id == undefined || this[`${type}Address`].country_id == null) return false;
      return true;
    },
    // PAYMENT TERMS - CUSTOMS INFORMATION
    updateIncotermsServices(val) {
      this.incotermServices = val;
    },
    formatUnits(num) {
      let number = num.toString();
      if(number.indexOf(',') > -1){
        number = number.replace(/,/g, '.');
      }
      return Number(number);
    },
    parseColli() {
      let dataArray = [];
      const colliArray = this.shipmentPackages;
      let colliNameNumber = 1;
      for(let ii=0; colliArray.length > ii; ii++){

        const goodsTypeName = colliArray[ii].goodsTypeName;

        if( colliArray[ii].colli > 1){
          for(let kk=0; colliArray[ii].colli > kk; kk++){
            dataArray.push(this.parseColliDataForAPICall(colliArray[ii], `${goodsTypeName} ${colliNameNumber}`, goodsTypeName.toLowerCase(), `Group-${ii}`, ii));
            colliNameNumber++;
          }
        } else {
          dataArray.push(this.parseColliDataForAPICall(colliArray[ii], `${goodsTypeName} ${colliNameNumber}`, goodsTypeName.toLowerCase(), `Group-${ii}`, ii));
          colliNameNumber++;
        }
      }

      return dataArray;
    },
    parseColliDataForAPICall(colli, additionalName, type, group, shipmentPackagesIndex) {
      const showContent = this.showColliContent[shipmentPackagesIndex]
      if(type === 'pallet') {
        return {
          goods_type: colli.goodsType,
          colli_number: additionalName,
          group: group,
          //pallet_type: colli.palleteType,
          package_id: colli.palleteType,
          packaging_name: colli.packagingName,
          description: colli.description,  //showContent ? null : colli.description,
          // weight: showContent ? null : colli.colliWeight.value,
          weight: colli.colliWeight.value,
          weight_type: colli.colliWeight.unit,
          //weight_type: showContent ? null : colli.colliWeight.unit,
          height: colli.dimensions.height.value,
          length: colli.dimensions.length.value,
          width: colli.dimensions.width.value,
          dimension_type: 'cm',
          pallet_stackable_type: colli.pallet_stackable_type,
          pallet_space: colli.palletSpace,
          pallet_exchange: colli.palleteExchange,
          isTemperature: colli.isTemperature,
          min_temp: colli.minTemperature,
          max_temp: colli.maxTemperature,
          isDgToggleActive: colli.isDgToggleActive,
          content_json: this.transformColliContent(shipmentPackagesIndex, colli.content),
          services_json: this.transformColliService(colli)
        };
      }
      if(type === 'parcel') {
        return {
          goods_type: colli.goodsType,
          colli_number: additionalName,
          group: group,
          package_id: colli.parcelType,
          packaging_name: colli.packagingName,
          description: colli.description, //showContent ? null : colli.description,
          // weight: showContent ? null : colli.colliWeight.value,
          weight: colli.colliWeight.value,
          weight_type: colli.colliWeight.unit,
          //weight_type: showContent ? null : colli.colliWeight.unit,
          height: colli.dimensions.height.value,
          length: colli.dimensions.length.value,
          width: colli.dimensions.width.value,
          dimension_type: colli.dimensions.dimensionsType,
          isTemperature: colli.isTemperature,
          min_temp: colli.minTemperature,
          max_temp: colli.maxTemperature,
          isDgToggleActive: colli.isDgToggleActive,
          content_json: this.transformColliContent(shipmentPackagesIndex, colli.content),
          services_json: this.transformColliService(colli)
        };
      }
      if(type === 'document') {
        let colliWeightValue = colli.colliWeight.value == '' || colli.colliWeight.value == undefined ? 0 : this.formatUnits(colli.colliWeight.value);
        return {
          goods_type: colli.goodsType,
          colli_number: additionalName,
          group: group,
          package_id: colli.parcelType,
          packaging_name: colli.packagingName,
          description: colli.description,
          // weight: showContent ? null : colli.colliWeight.value,
          weight: colli.colliWeight.value,
          weight_type: colli.colliWeight.unit,
          //weight_type: showContent ? null : colli.colliWeight.unit,
          height: colli.dimensions.height.value,
          length: colli.dimensions.length.value,
          width: colli.dimensions.width.value,
          dimension_type: colli.dimensions.dimensionsType,
          services_json: [],
          content_json: [],
        };
      }
      if(type === 'load') {
        return {
          goods_type: colli.goodsType,
          colli_number: additionalName,
          group: group,
          package_id: colli.parcelType,
          packaging_name: colli.packagingName,
          description: colli.description, //showContent ? null : colli.description,
          // weight: showContent ? null : colli.colliWeight.value,
          weight: colli.colliWeight.value,
          weight_type: colli.colliWeight.unit,
          //weight_type: showContent ? null : colli.colliWeight.unit,
          height: colli.dimensions.height.value,
          length: colli.dimensions.length.value,
          width: colli.dimensions.width.value,
          dimension_type: colli.dimensions.dimensionsType,
          cubic_meter: colli.cubicMeter,
          load_meter: colli.loadMeter,
          isTemperature: colli.isTemperature,
          min_temp: colli.minTemperature,
          max_temp: colli.maxTemperature,
          isDgToggleActive: colli.isDgToggleActive,
          content_json: this.transformColliContent(shipmentPackagesIndex, colli.content),
          services_json: this.transformColliService(colli)
        };
      }
    },
    parseColliObservable() {
      let dataArray = [];
      const colliArray = this.shipmentPackages;

      let colliNameNumber = 1;
      for(let ii=0; colliArray.length > ii; ii++){

        const goodsTypeName = colliArray[ii].goodsTypeName;

        if( colliArray[ii].colli > 1){
          for(let kk=0; colliArray[ii].colli > kk; kk++){
            dataArray.push(this.parseColliDataForAPICallObservable(colliArray[ii], `${goodsTypeName} ${colliNameNumber}`, goodsTypeName.toLowerCase(), `Group-${ii}`, ii));
            colliNameNumber++;
          }
        } else {
          dataArray.push(this.parseColliDataForAPICallObservable(colliArray[ii], `${goodsTypeName} ${colliNameNumber}`, goodsTypeName.toLowerCase(), `Group-${ii}`, ii));
          colliNameNumber++;
        }
      }

      return dataArray;
    },
    parseColliDataForAPICallObservable(colli, additionalName, type, group, shipmentPackagesIndex) {
      const showContent = this.showColliContent[shipmentPackagesIndex]
      if(type === 'pallet') {
        return {
          goods_type: colli.goodsType,
          colli_number: additionalName,
          group: group,
          package_id: colli.palleteType,
          packaging_name: colli.packagingName,
          // weight: showContent ? null : colli.colliWeight.value,
          weight: colli.colliWeight.value,
          weight_type: colli.colliWeight.unit,
          //weight_type: showContent ? null : colli.colliWeight.unit,
          height: colli.dimensions.height.value,
          length: colli.dimensions.length.value,
          width: colli.dimensions.width.value,
          dimension_type: 'cm',
          pallet_stackable_type: colli.pallet_stackable_type,
          pallet_space: colli.palletSpace,
          pallet_exchange: this.transformPalletExchange(colli.palleteExchange),
          isTemperature: colli.isTemperature,
          min_temp: colli.minTemperature,
          max_temp: colli.maxTemperature,
          isDgToggleActive: colli.isDgToggleActive,
          content_json: this.transformColliContent(shipmentPackagesIndex, colli.content, true),
          services_json: this.transformColliService(colli, true)
        };
      }
      if(type === 'parcel') {
        return {
          goods_type: colli.goodsType,
          colli_number: additionalName,
          group: group,
          package_id: colli.parcelType,
          packaging_name: colli.packagingName,
          // weight: showContent ? null : colli.colliWeight.value,
          weight: colli.colliWeight.value,
          weight_type: colli.colliWeight.unit,
          //weight_type: showContent ? null : colli.colliWeight.unit,
          height: colli.dimensions.height.value,
          length: colli.dimensions.length.value,
          width: colli.dimensions.width.value,
          dimension_type: colli.dimensions.dimensionsType,
          isTemperature: colli.isTemperature,
          min_temp: colli.minTemperature,
          max_temp: colli.maxTemperature,
          isDgToggleActive: colli.isDgToggleActive,
          content_json: this.transformColliContent(shipmentPackagesIndex, colli.content, true),
          services_json: this.transformColliService(colli, true)
        };
      }
      if(type === 'document') {
        let colliWeightValue = colli.colliWeight.value == '' || colli.colliWeight.value == undefined ? 0 : this.formatUnits(colli.colliWeight.value);
        return {
          goods_type: colli.goodsType,
          colli_number: additionalName,
          group: group,
          package_id: colli.parcelType,
          packaging_name: colli.packagingName,
          // weight: showContent ? null : colli.colliWeight.value,
          weight: colli.colliWeight.value,
          weight_type: colli.colliWeight.unit,
          //weight_type: showContent ? null : colli.colliWeight.unit,
          height: colli.dimensions.height.value,
          length: colli.dimensions.length.value,
          width: colli.dimensions.width.value,
          dimension_type: colli.dimensions.dimensionsType,
        };
      }
      if(type === 'load') {
        return {
          goods_type: colli.goodsType,
          colli_number: additionalName,
          group: group,
          package_id: colli.parcelType,
          packaging_name: colli.packagingName,
          // weight: showContent ? null : colli.colliWeight.value,
          weight: colli.colliWeight.value,
          weight_type: colli.colliWeight.unit,
          //weight_type: showContent ? null : colli.colliWeight.unit,
          height: colli.dimensions.height.value,
          length: colli.dimensions.length.value,
          width: colli.dimensions.width.value,
          dimension_type: colli.dimensions.dimensionsType,
          cubic_meter: colli.cubicMeter,
          load_meter: colli.loadMeter,
          isTemperature: colli.isTemperature,
          min_temp: colli.minTemperature,
          max_temp: colli.maxTemperature,
          isDgToggleActive: colli.isDgToggleActive,
          content_json: this.transformColliContent(shipmentPackagesIndex, colli.content, true),
          services_json: this.transformColliService(colli, true)
        };
      }
    },
    addColliItem(){
      let item;

      if ("goods_type_id" in this.get_user && this.get_user.goods_type_id !== undefined) {
        const userPrefGoodsType = parseInt(this.get_user.goods_type_id)

        if(userPrefGoodsType === 1) {
          item = this.defaultPackageBlocks.parcel;
          item.dangerousGoodsServices[0].feeWrapperId = this.dgType;
          item.parcelType = this.get_user.parcel_package_id ?? null
        }
        if(userPrefGoodsType === 2) {
          item = this.defaultPackageBlocks.document
          item.parcelType = this.get_user.document_package_id ?? null
        }
        if(userPrefGoodsType === 3) {
          item = this.defaultPackageBlocks.pallet
          item.dangerousGoodsServices[0].feeWrapperId = this.dgType;
          item.palleteType = this.get_user.pallet_package_id && parseInt(this.get_user.pallet_package_id) !== 5019 //'Pallet - unspecified'
            ? this.get_user.pallet_package_id
            : 5015 //'Euro pallet - 120cm x 80cm'
          item.pallet_stackable_type = this.get_user.stackable || 'stackable'
        }
        if(userPrefGoodsType === 4) {
          item = this.defaultPackageBlocks.load
          item.parcelType = this.get_user.load_package_id ?? null
          item.dangerousGoodsServices[0].feeWrapperId = this.dgType;
        }
      } else {
        //by default add PARCEL
        item = this.defaultPackageBlocks.parcel;
        item.parcelType = this.get_user.package_id ?? null;
        item.dangerousGoodsServices[0].feeWrapperId = this.dgType;
      }

      let lastPackage = JSON.parse(JSON.stringify(this.shipmentPackages)).pop();
      let packageToCreate = JSON.parse(JSON.stringify(item))

      // If some package already added we want to make a copy of its description
      if (lastPackage && !this.showColliContent[this.shipmentPackages.indexOf(lastPackage)]) {
          packageToCreate.description = lastPackage.description;
      }
      this.shipmentPackages.push(packageToCreate)
      this.updateActiveGoodsTypes();
      this.setShowColliContent();
    },
    updateGoodsType(val, index) {
      let defaultObject = {}

      const firstPackageDim = this.get_editing_shipment?.storeShipmentPackages[0]?.dimensions;
      const firstPackageHasProperDim = (firstPackageDim !== undefined)
        && this.shouldUseShipmentMeasure(firstPackageDim.length.value)
        && this.shouldUseShipmentMeasure(firstPackageDim.width.value)
        && this.shouldUseShipmentMeasure(firstPackageDim.height.value);

      // If pallet type we want to delete the width and length and let other types to set their default values
      if (this.shipmentPackages[index].goodsType === 3 && val !== 3) {
        if (firstPackageHasProperDim) {
          this.shipmentPackages[index].colliWeight = this.get_editing_shipment.storeShipmentPackages[0].colliWeight
          this.shipmentPackages[index].dimensions = this.get_editing_shipment.storeShipmentPackages[0].dimensions
        } else {
          if(val === 1) {
            this.shipmentPackages[index].dimensions = this.defaultPackageBlocks.parcel.dimensions
          }
          if(val === 2) {
            this.shipmentPackages[index].dimensions = this.defaultPackageBlocks.document.dimensions
          }
          if(val === 4) {
            this.shipmentPackages[index].dimensions = this.defaultPackageBlocks.load.dimensions
          }
        }
      }

      if(val === 1) {
        if (firstPackageHasProperDim) {
          defaultObject.dimensions = this.get_editing_shipment.storeShipmentPackages[0].dimensions
        } else {
          this.defaultPackageBlocks.parcel.parcelType = this.get_user.parcel_package_id ?? null
          this.shipmentPackages[index].parcelType = this.get_user.parcel_package_id ?? null
        }
        defaultObject = this.defaultPackageBlocks.parcel;
      }
      if(val === 2) {
        if (firstPackageHasProperDim) {
          defaultObject.dimensions = this.get_editing_shipment.storeShipmentPackages[0].dimensions
        } else {
          this.defaultPackageBlocks.document.parcelType = this.get_user.document_package_id ?? null
        }
        defaultObject = this.defaultPackageBlocks.document;
      }
      if(val === 3) {
        this.defaultPackageBlocks.pallet.palleteType = this.get_user.pallet_package_id && parseInt(this.get_user.pallet_package_id) !== 5019 //'Pallet - unspecified'
          ? this.get_user.pallet_package_id
          : 5015 //'Euro pallet - 120cm x 80cm'

        this.defaultPackageBlocks.pallet.pallet_stackable_type = this.get_user.stackable || 'stackable'
        defaultObject = this.defaultPackageBlocks.pallet;
        if (firstPackageDim !== undefined && firstPackageDim.height.value > 1) {
          defaultObject.dimensions.height = this.get_editing_shipment.storeShipmentPackages[0].dimensions.height
        }
      }
      if(val === 4) {
        if (firstPackageHasProperDim) {
          defaultObject.dimensions = this.get_editing_shipment.storeShipmentPackages[0].dimensions
        } else {
          this.defaultPackageBlocks.load.parcelType = this.get_user.load_package_id ?? null
          this.defaultPackageBlocks.load.parcelType = this.get_user.load_package_id ?? null
        }
        defaultObject = this.defaultPackageBlocks.load;
      }

      const mergedObject = this.mergeShipmentPackages(this.shipmentPackages[index], defaultObject);
      this.$set(this.shipmentPackages, index, mergedObject);

      this.updateActiveGoodsTypes();
      this.setShowColliContent();
      this.palletExchangeServiceCheck();
    },
    updateActiveGoodsTypes()
    {
      const goodsTypes = [];
      this.shipmentPackages.forEach((shipmentPackage) => {
        if (!goodsTypes.includes(shipmentPackage.goodsType)) {
          goodsTypes.push(shipmentPackage.goodsType);
        }
      })
      this.activeGoodsTypes = goodsTypes
    },
    removePackage(index) {
      this.shipmentPackages.splice(index, 1);
      this.updateActiveGoodsTypes();
      this.setShowColliContent();
    },
    palletExchangeServiceCheck() {
      let turnOnPalletExchangeService = false
      this.shipmentPackages.forEach((shipmentPackage) => {
        if (shipmentPackage.goodsType === 3 && shipmentPackage.palleteExchange) {
          const hasValidExchange = shipmentPackage.palleteExchange.some(exchange =>
            exchange.value && parseInt(exchange.value) > 0
          );
          if (hasValidExchange) {
            turnOnPalletExchangeService = true;
          }
        }
      });

      const index = this.externallyInjectedServices.indexOf(this.palletExchangeServiceId);

      console.log('PALLET_CHECK', index, turnOnPalletExchangeService)

      if (turnOnPalletExchangeService && this.palletExchangeServiceId && index < 0) {
        this.externallyInjectedServices.push(this.palletExchangeServiceId);
      } else if (!turnOnPalletExchangeService && index >= 0) {
        this.externallyInjectedServices.splice(index, 1);
      }
    },
    // BOOKING
    printShipment() {
      this.$refs.printPDF.contentWindow.print();
    },
    redirectFromShipment() {
      this.$router.push(`/view-shipment/${this.shipmentId}`);
    },
    downloadShipment() {
      this.$refs.downloadPDF.click();
    },
    downloadDGFile() {
      this.$store.dispatch('GET_DG_FILE', this.shipmentId).then((res) => {
        this.$nextTick(() => {
          let file = window.URL.createObjectURL(res);
          this.$refs.downloadDgRef.href = file;
          this.dgPdfPath = file;
          this.$refs.downloadDgRef.click();
        })
      })
    },
    downloadEOD() {
      this.$store.dispatch('DOWNLOAD_EOD', this.shipmentId).then((res) => {
        this.$nextTick(() => {
          let file = window.URL.createObjectURL(res);
          this.$refs.downloadEODPDF.href = file;
          this.eodPdfPath = file;
          this.$refs.downloadEODPDF.click();
        })
      })
    },
    closeShipmentPopup() {
      this.showShipmentPopup = false;
      this.isPDFGenerated = false;
      this.dgFilePath = '';
      this.dgPdfPath = '';
      this.eodPdfPath = '';
      this.batchNumber = null;
      this.downloadEodName = '';
      this.resetShippment()
    },
    checkCustoms() {
      this.$store.dispatch('GET_CUSTOMS_DECLARABLE', {
        fromCountry: this.fromAddress.country_id,
        fromPostcode: this.fromAddress.post_code,
        toCountry: this.toAddress.country_id,
        toPostcode: this.toAddress.post_code,
        goods_type: JSON.stringify(this.activeGoodsTypes),
      }).then((res) => {
        this.showCustoms = res;
        this.showOrigin = res;
        this.setShowColliContent()
      })
    },
  },
  watch: {
    bookingType(newVal) {
      if (newVal === 'quote') {
        // Save shipper so it can be restored when switching back to standard.
        // Do NOT clear fromAddress — quote mode uses fromAddress.country_id /
        // fromAddress.post_code directly and they should stay pre-filled.
        this._shipperBeforeQuote = this.shipper;
      } else if (newVal === 'standard') {
        if (this._shipperBeforeQuote) {
          this.shipper = this._shipperBeforeQuote;
          this.checkForForeignShipper(this._shipperBeforeQuote);
          this._shipperBeforeQuote = null;
        }
      }
    },
    systemShowColliContent() {
      this.setShowColliContent()
    },
    'activeGoodsTypes': function() {
      if(this.isInfoValid('from') && this.isInfoValid('to')){
        this.checkCustoms();
      }
    },
    'fromAddress.country_id': {
      handler(newVal){
        if(((this.fromData.phone.number && this.fromData.phone.number.length < 5) || !this.fromData.phone.number) && String(newVal) !== ''){
          this.fromData.phone.country = this.getCountry(newVal, 'alpha2');
        }
        if(String(newVal) !== ''){
          // this.showCombinedState();
          if(this.isInfoValid('from') && this.isInfoValid('to')){
            this.checkCustoms();
          }
        }
      },
      deep: true
    },
    // 'content': {
    //   handler(newVal){
    //     if (newVal) {
    //       this.calculateShipmentTotalContentAmount(newVal);
    //     }
    //   },
    //   deep: true
    // },
    'fromAddress.post_code': {
      handler(){
        if(this.isInfoValid('from') && this.isInfoValid('to')){
          this.checkCustoms();
        }
      },
      deep: true
    },
    'toData.shipToPrivateResident': {
      handler(newVal){
        if (newVal === true) {
          this.toData.company = '';
        }
      },
      deep: true
    },
    'fromData.shipFromPrivateResident': {
      handler(newVal){
        if (newVal === true) {
          this.fromData.company = '';
        }
      },
      deep: true
    },
    'waybillAddress.country_id': {
      handler(newVal){
        if(this.waybillData?.phone?.number && this.waybillData.phone.number.length < 5 && String(newVal) !== ''){
          this.waybillData.phone.country = this.getCountry(newVal, 'alpha2');
        }
      },
      deep: true
    },
    toWaybill: function(val) {
      if(!val) {
        this.waybillShipper = null;
        this.waybillAddress.address_1 = '';
        this.waybillAddress.address_2 = '';
        this.waybillAddress.country_id = '';
        this.waybillAddress.post_code = '';
        this.waybillAddress.city = '';
        this.waybillAddress.state = '';
      }
    },
    infoCustomer: function(val) {
      //if(!val) this.clearInvoiceData();
    },
    'toAddress.country_id': {
      handler(newVal){
        if(this.toData.phone.number.length < 5 && String(newVal) !== ''){
          this.toData.phone.country = this.getCountry(newVal, 'alpha2');
        }
        if(String(newVal) !== ''){
          // this.showCombinedState();
          if(this.isInfoValid('from') && this.isInfoValid('to')){
            this.checkCustoms();
          }
        }
      },
      deep: true
    },
    'toAddress.post_code': {
      handler(){
        if(this.isInfoValid('from') && this.isInfoValid('to')){
          this.checkCustoms();
        }
      },
      deep: true
    },
  },
  mounted() {
    if (this.shipmentPackages.length === 0) {
      this.addColliItem()
    }

    if (!this.get_shipment_editing_mode && this.$store.getters.get_user && this.$store.getters.get_user.receiver_country_id) {
      this.toAddress.country_id = this.$store.getters.get_user.receiver_country_id
    }

    // Apply default currency for new bookings (not editing/copy). Avoid touching existing currencies on edit.
    if (!this.get_shipment_editing_mode) {
      const userCurrency = (this.$store.getters.get_user && this.$store.getters.get_user.currency)
        ? String(this.$store.getters.get_user.currency).toLowerCase()
        : null;
      if (userCurrency) {
        this.shipmentPackages = this.shipmentPackages.map(pkg => {
          if (Array.isArray(pkg.content)) {
            pkg.content = pkg.content.map(c => {
              const currentUnit = String(c?.unitValue?.unit || '').toLowerCase();
              const shouldSet = !currentUnit || currentUnit.trim() === '' || currentUnit === 'dkk';
              if (shouldSet) {
                const value = c?.unitValue?.value !== undefined ? c.unitValue.value : '';
                return { ...c, unitValue: { value, unit: userCurrency } };
              }
              return c;
            });
          }
          return pkg;
        });
      }
    }

    this.$store.dispatch('GET_PALLETE_TYPES').then(() => {
      console.log('Pallet types loaded in main component');
    });


    this.$store.dispatch('GET_DANGEROUS_GOODS').then(() => {
      this.dangerousGoodsLoaded = true;
    })

    this.$store.dispatch('GET_PALLET_EXCHANGE_SERVICE', {
      category: '15', // ovo je zakucana kategorija na pallet exchange
    }).then((res) => {
      this.palletExchangeServiceId = res.data.data.id;
      this.palletExchangeServiceCheck()
    });
  },
  destroyed() {
    this.$store.dispatch('CLEAR_EDITING_SHIPMENT');
    this.$store.dispatch('CLEAR_PARCEL_TYPES');
  },
};
</script>
<style lang="scss">
  .book-shipment-address-card {
    min-height: 800px;
    display: flex;
    flex-direction: column;
  }

  [v-cloak] {
    display: none;
  }
</style>
